(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('tslib'), require('@tsdi/ioc'), require('@tsdi/boot'), require('@tsdi/core')) :
	typeof define === 'function' && define.amd ? define(['tslib', '@tsdi/ioc', '@tsdi/boot', '@tsdi/core'], factory) :
	(global = global || self, (global.components = global.components || {}, global.components.umd = factory(global.tslib, global.ioc, global.boot, global.core)));
}(this, (function (tslib, ioc, boot, core) { 'use strict';

	tslib = tslib && Object.prototype.hasOwnProperty.call(tslib, 'default') ? tslib['default'] : tslib;
	ioc = ioc && Object.prototype.hasOwnProperty.call(ioc, 'default') ? ioc['default'] : ioc;
	boot = boot && Object.prototype.hasOwnProperty.call(boot, 'default') ? boot['default'] : boot;
	core = core && Object.prototype.hasOwnProperty.call(core, 'default') ? core['default'] : core;

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var IBinding = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });


	});

	unwrapExports(IBinding);

	var IPipeTransform = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });


	});

	unwrapExports(IPipeTransform);

	var Events_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Events = void 0;
	/**
	 * events.
	 *
	 * @export
	 * @class Events
	 */
	var Events = /** @class */ (function () {
	    function Events() {
	        this.maps = {};
	    }
	    /**
	     * subscribe event.
	     *
	     * @param {string} event the evnet subscribe.
	     * @param {(...args: any[]) => void} handle
	     * @memberof Events
	     */
	    Events.prototype.on = function (event, handle) {
	        this.maps[event] = this.maps[event] || [];
	        if (this.maps[event].indexOf(handle) < 0) {
	            this.maps[event].push(handle);
	        }
	    };
	    /**
	     * unsubscribe event.
	     *
	     * @param {string} event the event to unsubscribe.
	     * @param {...Function[]} handles
	     * @memberof Events
	     */
	    Events.prototype.off = function (event) {
	        var handles = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            handles[_i - 1] = arguments[_i];
	        }
	        if (handles.length) {
	            if (this.maps[event]) {
	                this.maps[event] = this.maps[event].filter(function (h) { return handles.indexOf(h) < 0; });
	            }
	        }
	        else {
	            delete this.maps[event];
	        }
	    };
	    /**
	     * emit event.
	     *
	     * @param {string} event event type.
	     * @param {...any[]} args
	     * @memberof Events
	     */
	    Events.prototype.emit = function (event) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var hanldes = this.maps[event] || [];
	        hanldes.forEach(function (h) {
	            h.apply(void 0, args);
	        });
	    };
	    Events.ρAnn = function () {
	        return { "name": "Events" };
	    };
	    return Events;
	}());
	exports.Events = Events;


	});

	unwrapExports(Events_1);
	var Events_2 = Events_1.Events;

	var onChange = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.observe = void 0;



	var fdChg = 'fieldChanged';
	/**
	 * observe property change.
	 */
	var observe;
	(function (observe) {
	    var events = new WeakMap();
	    var defines = new WeakMap();
	    /**
	     * get events of target object.
	     *
	     * @export
	     * @param {*} target
	     * @returns {Events}
	     */
	    function getEvents(target) {
	        return events.get(target);
	    }
	    observe.getEvents = getEvents;
	    /**
	     * target has envents or not.
	     *
	     * @export
	     * @param {*} target
	     * @returns {boolean}
	     */
	    function hasEvents(target) {
	        return events.has(target);
	    }
	    observe.hasEvents = hasEvents;
	    /**
	     * on property change.
	     *
	     * @export
	     * @param {*} target subscribe change handle of target.
	     * @param {(string | ((tag: T) => any))} property subscribe change handle of target property.
	     * @param {(vaule?: any, old?: any, target?: any, prop?: string) => void} onChange change handle.
	     * @returns
	     */
	    function onPropertyChange(target, property, onChange, changed) {
	        var evt;
	        if (!events.has(target)) {
	            evt = new Events_1.Events();
	            events.set(target, evt);
	        }
	        else {
	            evt = events.get(target);
	        }
	        var descriptors = Object.getOwnPropertyDescriptors(ioc.lang.getClass(target).prototype);
	        var propName;
	        if (ioc.isFunction(property)) {
	            var objMap_1 = {};
	            tslib.__spreadArrays(Object.keys(target), Object.keys(descriptors)).forEach(function (k) {
	                if (!objMap_1[k]) {
	                    objMap_1[k] = k;
	                }
	            });
	            propName = property(objMap_1);
	        }
	        else {
	            propName = property;
	        }
	        if (!defines.has(target) || !defines.get(target)[propName]) {
	            var descriptor_1 = descriptors[propName];
	            var value_1 = Reflect.get(target, propName);
	            Reflect.defineProperty(target, propName, {
	                get: function () {
	                    if (descriptor_1 && descriptor_1.get) {
	                        return descriptor_1.get.call(target);
	                    }
	                    else {
	                        return value_1;
	                    }
	                },
	                set: function (val) {
	                    var isChanged = value_1 !== val;
	                    var old = value_1;
	                    value_1 = val;
	                    if (descriptor_1 && descriptor_1.set) {
	                        descriptor_1.set.call(target, val);
	                    }
	                    if (isChanged) {
	                        evt.emit(fdChg, target, propName, val, old);
	                    }
	                }
	            });
	            var pps = defines.get(target) || {};
	            pps[propName] = true;
	            defines.set(target, pps);
	        }
	        evt.on(fdChg, function (tg, prop, val, old) {
	            if (target === tg) {
	                if (prop === propName) {
	                    onChange(val, old, tg, prop);
	                }
	                changed && changed(tg, prop, val, old);
	            }
	        });
	    }
	    observe.onPropertyChange = onPropertyChange;
	    /**
	     * on property changed.
	     *
	     * @export
	     * @template T
	     * @param {T} target
	     * @param {(string | ((tag: T) => any))} property
	     * @param {(vaule?: any, old?: any, target?: T, prop?: string) => void} callback
	     */
	    function onChanged(target, property, callback, changed) {
	        onPropertyChange(target, property, callback, changed);
	    }
	    observe.onChanged = onChanged;
	})(observe = exports.observe || (exports.observe = {}));


	});

	unwrapExports(onChange);
	var onChange_1 = onChange.observe;

	var exps = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pipeExp = exports.attrExp = exports.pathCkExp = exports.filedMatch = void 0;
	exports.filedMatch = /[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*/g;
	exports.pathCkExp = /\./;
	exports.attrExp = /^\[\w+\]$/;
	exports.pipeExp = /(\s\|\s\w+(:.+)?)+$/;


	});

	unwrapExports(exps);
	var exps_1 = exps.pipeExp;
	var exps_2 = exps.attrExp;
	var exps_3 = exps.pathCkExp;
	var exps_4 = exps.filedMatch;

	var PropBinding_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PropBinding = void 0;



	/**
	 * property binding.
	 *
	 * @export
	 * @abstract
	 * @class DataBinding
	 * @template T
	 */
	var PropBinding = /** @class */ (function () {
	    function PropBinding(injector, provider, source, binding, expression) {
	        this.injector = injector;
	        this.provider = provider;
	        this.source = source;
	        this.binding = binding;
	        this.expression = expression;
	        this.fields = [];
	    }
	    PropBinding.prototype.getScope = function () {
	        var _this = this;
	        if (!this.map) {
	            this.map = this.provider.getAstResolver().parseScope(this.expression, this.source);
	            this.map.forEach(function (v, k) {
	                if (!ioc.isFunction(v)) {
	                    _this.fields.push(k);
	                }
	            });
	            return this.map;
	        }
	        else {
	            this.fields.forEach(function (k) {
	                _this.map.set(k, _this.source[k]);
	            });
	            return this.map;
	        }
	    };
	    PropBinding.prototype.resolveExression = function () {
	        if (!this.parser) {
	            this.parser = this.provider.getAstResolver().parse(this.expression, this.injector);
	        }
	        return this.parser(this.getScope());
	    };
	    PropBinding.prototype.getFileds = function () {
	        if (!this.fieldExps) {
	            var idx = this.expression.search(exps.pipeExp);
	            var exp = idx > 0 ? this.expression.substring(0, idx) : this.expression;
	            this.fieldExps = exp.match(exps.filedMatch).map(function (v) { return v; });
	        }
	        return this.fieldExps;
	    };
	    PropBinding.prototype.bindTagChange = function (field, target) {
	        var _this = this;
	        if (!ioc.isTypeObject(target)) {
	            return;
	        }
	        var astResolver = this.provider.getAstResolver();
	        var fieldName = this.binding.name;
	        if (exps.pathCkExp.test(field)) {
	            var paths = field.split('.');
	            var idx = field.lastIndexOf('.');
	            var scope_1 = field.substring(0, idx);
	            var sub_1 = astResolver.resolve(scope_1, this.injector, this.getScope());
	            var last_1 = field.substring(idx + 1);
	            onChange.observe.onPropertyChange(this.source, ioc.lang.first(paths), function (value, oldVal) {
	                target[fieldName] = _this.resolveExression();
	                if (sub_1) {
	                    onChange.observe.getEvents(sub_1).off('fieldChanged');
	                }
	                sub_1 = astResolver.resolve(scope_1, _this.injector, _this.source);
	                onChange.observe.onPropertyChange(sub_1, last_1, function (value, oldVal) {
	                    target[fieldName] = _this.resolveExression();
	                });
	            });
	            if (sub_1) {
	                onChange.observe.onPropertyChange(sub_1, last_1, function (value, oldVal) {
	                    target[fieldName] = _this.resolveExression();
	                });
	            }
	        }
	        else {
	            onChange.observe.onPropertyChange(this.source, field, function (value, oldVal) {
	                target[fieldName] = _this.resolveExression();
	            });
	        }
	    };
	    PropBinding.ρAnn = function () {
	        return { "name": "PropBinding" };
	    };
	    return PropBinding;
	}());
	exports.PropBinding = PropBinding;


	});

	unwrapExports(PropBinding_1);
	var PropBinding_2 = PropBinding_1.PropBinding;

	var EventBinding_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.EventBinding = void 0;



	var EventBinding = /** @class */ (function (_super) {
	    tslib.__extends(EventBinding, _super);
	    function EventBinding() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    EventBinding.prototype.bind = function (target) {
	        var _this = this;
	        var $scope = this.source;
	        var outEvent = target[this.binding.name];
	        if (outEvent && ioc.isObservable(this.binding.type)) {
	            outEvent.subsrcibe(function ($event) {
	                var result = _this.provider.getAstResolver().resolve(_this.expression, _this.injector, _this.getScope(), { target: target, $scope: $scope, $event: $event });
	                if (ioc.isFunction(result)) {
	                    result($event);
	                }
	            });
	        }
	    };
	    EventBinding.ρAnn = function () {
	        return { "name": "EventBinding" };
	    };
	    return EventBinding;
	}(PropBinding_1.PropBinding));
	exports.EventBinding = EventBinding;


	});

	unwrapExports(EventBinding_1);
	var EventBinding_2 = EventBinding_1.EventBinding;

	var ParseBinding_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParseBinding = void 0;


	/**
	 * parse binding
	 *
	 * @export
	 * @class OneWayBinding
	 * @extends {PropBinding<T>}
	 * @template T
	 */
	var ParseBinding = /** @class */ (function (_super) {
	    tslib.__extends(ParseBinding, _super);
	    function ParseBinding() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParseBinding.ρAnn = function () {
	        return { "name": "ParseBinding" };
	    };
	    return ParseBinding;
	}(PropBinding_1.PropBinding));
	exports.ParseBinding = ParseBinding;


	});

	unwrapExports(ParseBinding_1);
	var ParseBinding_2 = ParseBinding_1.ParseBinding;

	var OneWayBinding_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.OneWayBinding = void 0;


	/**
	 * one way binding
	 *
	 * @export
	 * @class OneWayBinding
	 * @extends {DataBinding<T>}
	 * @template T
	 */
	var OneWayBinding = /** @class */ (function (_super) {
	    tslib.__extends(OneWayBinding, _super);
	    function OneWayBinding() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    OneWayBinding.prototype.bind = function (target, initVal) {
	        var _this = this;
	        if (!target) {
	            return;
	        }
	        target[this.binding.name] = initVal !== null && initVal !== void 0 ? initVal : this.resolveExression();
	        this.getFileds().forEach(function (field) {
	            _this.bindTagChange(field, target);
	        });
	    };
	    OneWayBinding.ρAnn = function () {
	        return { "name": "OneWayBinding" };
	    };
	    return OneWayBinding;
	}(ParseBinding_1.ParseBinding));
	exports.OneWayBinding = OneWayBinding;


	});

	unwrapExports(OneWayBinding_1);
	var OneWayBinding_2 = OneWayBinding_1.OneWayBinding;

	var TwoWayBinding_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TwoWayBinding = void 0;





	/**
	 * two way binding.
	 *
	 * @export
	 * @class TwoWayBinding
	 * @extends {ParseBinding<T>}
	 * @template T
	 */
	var TwoWayBinding = /** @class */ (function (_super) {
	    tslib.__extends(TwoWayBinding, _super);
	    function TwoWayBinding() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TwoWayBinding.prototype.bind = function (target, initVal) {
	        var _this = this;
	        if (!target) {
	            return;
	        }
	        var field = this.binding.name;
	        var fields = this.getFileds();
	        fields.forEach(function (f) {
	            _this.bindTagChange(f, target);
	        });
	        if (fields.length === 1) {
	            var fd = ioc.lang.first(fields);
	            var scopeExp = exps.pathCkExp.test(fd) ? fd.substring(0, fd.lastIndexOf('.')) : '';
	            var scopeParser_1 = this.provider.getAstResolver().parse(scopeExp, this.injector);
	            var scopeFile_1 = exps.pathCkExp.test(fd) ? fd.substring(fd.lastIndexOf('.') + 1) : fd;
	            onChange.observe.onPropertyChange(target, field, function (value, oldVal) {
	                var scope = scopeParser_1 ? scopeParser_1(_this.getScope()) : _this.source;
	                scope[scopeFile_1] = value;
	            });
	        }
	        target[field] = initVal !== null && initVal !== void 0 ? initVal : this.resolveExression();
	    };
	    TwoWayBinding.ρAnn = function () {
	        return { "name": "TwoWayBinding" };
	    };
	    return TwoWayBinding;
	}(ParseBinding_1.ParseBinding));
	exports.TwoWayBinding = TwoWayBinding;


	});

	unwrapExports(TwoWayBinding_1);
	var TwoWayBinding_2 = TwoWayBinding_1.TwoWayBinding;

	var BindingPropMetadata = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });


	});

	unwrapExports(BindingPropMetadata);

	var IComponentMetadata = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });


	});

	unwrapExports(IComponentMetadata);

	var Component = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Component = void 0;

	/**
	 * Component decorator, define for class. use to define the class as Component. it can setting provider to some token, singleton or not. it will execute  [`ComponentLifecycle`]
	 *
	 * @Component
	 */
	exports.Component = ioc.createClassDecorator('Component', [
	    function (ctx, next) {
	        if (ioc.isString(ctx.currArg)) {
	            ctx.metadata.selector = ctx.currArg;
	            ctx.next(next);
	        }
	    }
	]);


	});

	unwrapExports(Component);
	var Component_1 = Component.Component;

	var Input = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Input = void 0;

	/**
	 * Input decorator.
	 */
	exports.Input = ioc.createPropDecorator('Input', [
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ioc.isString(arg)) {
	            ctx.metadata.bindingName = arg;
	            ctx.next(next);
	        }
	        else if (ioc.isClassType(arg) || arg instanceof ioc.Registration) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	    },
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if ((ctx.args.length > 2 && ioc.isToken(arg))) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	        else {
	            ctx.metadata.defaultValue = arg;
	        }
	    },
	    function (ctx, next) {
	        ctx.metadata.defaultValue = ctx.currArg;
	    }
	], function (meta) {
	    meta.direction = 'input';
	});


	});

	unwrapExports(Input);
	var Input_1 = Input.Input;

	var Output = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Output = void 0;

	/**
	 * output property decorator.
	 */
	exports.Output = ioc.createPropDecorator('Output', [
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ioc.isString(arg)) {
	            ctx.metadata.bindingName = arg;
	            ctx.next(next);
	        }
	        else if (ioc.isClassType(arg) || arg instanceof ioc.Registration) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	    },
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ctx.args.length > 2 && ioc.isToken(arg)) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	        else {
	            ctx.metadata.defaultValue = arg;
	        }
	    },
	    function (ctx, next) {
	        ctx.metadata.defaultValue = ctx.currArg;
	    }
	], function (meta) {
	    meta.direction = 'output';
	});


	});

	unwrapExports(Output);
	var Output_1 = Output.Output;

	var RefChild = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RefChild = void 0;

	/**
	 * RefChild decorator, define for class. use to define the class. it can setting provider to some token, singleton or not. it will execute  [`RefChildLifecycle`]
	 *
	 * @RefChild
	 */
	exports.RefChild = ioc.createPropDecorator('RefChild', [
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ioc.isString(arg)) {
	            ctx.metadata.bindingName = arg;
	            ctx.next(next);
	        }
	        else if (ioc.isClassType(arg) || arg instanceof ioc.Registration) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	    },
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ctx.args.length > 2 && ioc.isToken(arg)) {
	            ctx.metadata.provider = arg;
	            ctx.next(next);
	        }
	        else {
	            ctx.metadata.defaultValue = arg;
	        }
	    },
	    function (ctx, next) {
	        ctx.metadata.defaultValue = ctx.currArg;
	    }
	]);


	});

	unwrapExports(RefChild);
	var RefChild_1 = RefChild.RefChild;

	var NonSerialize = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NonSerialize = void 0;

	/**
	 * @NonSerialize decorator define component property not need serialized.
	 */
	exports.NonSerialize = ioc.createPropDecorator('NonSerialize');


	});

	unwrapExports(NonSerialize);
	var NonSerialize_1 = NonSerialize.NonSerialize;

	var Vaildate = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Vaildate = void 0;

	/**
	 * Vaildate decorator.
	 */
	exports.Vaildate = ioc.createPropDecorator('Vaildate', [
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if (ioc.isBoolean(arg)) {
	            ctx.metadata.required = arg;
	            ctx.next(next);
	        }
	        else if (ioc.isFunction(arg)) {
	            ctx.metadata.vaild = arg;
	            ctx.next(next);
	        }
	    },
	    function (ctx, next) {
	        var arg = ctx.currArg;
	        if ((ctx.args.length > 2 && ioc.isString(arg))) {
	            ctx.metadata.errorMsg = arg;
	            ctx.next(next);
	        }
	    }
	]);


	});

	unwrapExports(Vaildate);
	var Vaildate_1 = Vaildate.Vaildate;

	var Pipe = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Pipe = void 0;

	/**
	 * Pipe decorator, define for class. use to define the class. it can setting provider to some token, singleton or not. it will execute  [`PipeLifecycle`]
	 *
	 * @Pipe
	 */
	exports.Pipe = ioc.createClassDecorator('Pipe', [
	    function (ctx, next) {
	        if (ioc.isString(ctx.currArg)) {
	            ctx.metadata.name = ctx.currArg;
	            ctx.next(next);
	        }
	    },
	    function (ctx, next) {
	        if (ioc.isBoolean(ctx.currArg)) {
	            ctx.metadata.prue = ctx.currArg;
	        }
	    },
	]);


	});

	unwrapExports(Pipe);
	var Pipe_1 = Pipe.Pipe;

	var ComponentSelectorHandle_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentSelectorHandle = void 0;



	/**
	 * component selector handle.
	 *
	 * @export
	 * @class ComponentSelectorHandle
	 * @extends {TemplateHandle}
	 */
	var ComponentSelectorHandle = /** @class */ (function (_super) {
	    tslib.__extends(ComponentSelectorHandle, _super);
	    function ComponentSelectorHandle() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ComponentSelectorHandle.prototype.execute = function (ctx, next) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var compPdr, template;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        compPdr = ctx.componentProvider;
	                        template = ctx.getTemplate();
	                        if (ioc.isArray(template) && ctx.getAnnoation().template === template) {
	                            ctx.selector = compPdr.getDefaultCompose();
	                        }
	                        else if (ioc.isClass(template) && compPdr.isNodeType(template)) {
	                            ctx.selector = template;
	                            ctx.remove(boot.CTX_TEMPLATE);
	                        }
	                        else if (template) {
	                            ctx.selector = this.getComponent(ctx, template, compPdr);
	                        }
	                        if (!!ctx.selector) return [3 /*break*/, 2];
	                        return [4 /*yield*/, next()];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ComponentSelectorHandle.prototype.getSelector = function (template, compdr) {
	        return template ? template[compdr.getSelectorKey()] : null;
	    };
	    ComponentSelectorHandle.prototype.getSelectorToken = function (compdr, selector) {
	        return compdr.toSelectorToken(selector);
	    };
	    ComponentSelectorHandle.prototype.getComponent = function (ctx, template, compdr) {
	        var selector = this.getSelector(template, compdr);
	        if (selector) {
	            if (ioc.isString(selector)) {
	                var selkey = this.getSelectorToken(compdr, selector);
	                return ctx.injector.getTokenProvider(selkey);
	            }
	            else if (compdr.isNodeType(selector)) {
	                return selector;
	            }
	        }
	        return null;
	    };
	    ComponentSelectorHandle.ρAnn = function () {
	        return { "name": "ComponentSelectorHandle" };
	    };
	    return ComponentSelectorHandle;
	}(boot.BuildHandle));
	exports.ComponentSelectorHandle = ComponentSelectorHandle;


	});

	unwrapExports(ComponentSelectorHandle_1);
	var ComponentSelectorHandle_2 = ComponentSelectorHandle_1.ComponentSelectorHandle;

	var ComponentRef_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.NullSelector = exports.NodeSelector = exports.ComponentRef = exports.TemplateRef = exports.ElementRef = exports.NodeRef = exports.COMPONENT_INST = exports.COMPONENT_TYPE = exports.COMPONENT_REF = exports.REFCHILD_SELECTOR = exports.ROOT_NODES = exports.TEMPLATE_REF = exports.NATIVE_ELEMENT = exports.ELEMENT_REF = exports.CONTEXT_REF = exports.ContextNode = exports.ELEMENT_REFS = exports.COMPONENT_REFS = exports.CTX_COMPONENT_REF = exports.CTX_TEMPLATE_SCOPE = exports.CTX_TEMPLATE_REF = exports.CTX_ELEMENT_REF = exports.CTX_COMPONENT = exports.CTX_COMPONENT_DECTOR = void 0;



	exports.CTX_COMPONENT_DECTOR = ioc.tokenId('CTX_COMPONENT_DECTOR');
	exports.CTX_COMPONENT = ioc.tokenId('CTX_COMPONENT');
	exports.CTX_ELEMENT_REF = ioc.tokenId('CTX_ELEMENT_REF');
	exports.CTX_TEMPLATE_REF = ioc.tokenId('CTX_TEMPLATE_REF');
	exports.CTX_TEMPLATE_SCOPE = ioc.tokenId('CTX_TEMPLATE_SCOPE');
	exports.CTX_COMPONENT_REF = ioc.tokenId('CTX_COMPONENT_REF');
	exports.COMPONENT_REFS = ioc.tokenId('COMPONENT_REFS');
	exports.ELEMENT_REFS = ioc.tokenId('ELEMENT_REFS');
	var ContextNode = /** @class */ (function (_super) {
	    tslib.__extends(ContextNode, _super);
	    function ContextNode(context) {
	        var _this = _super.call(this) || this;
	        _this._context = context;
	        return _this;
	    }
	    Object.defineProperty(ContextNode.prototype, "context", {
	        get: function () {
	            return this._context;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ContextNode.prototype.destroying = function () {
	        this._context.destroy();
	        this._context = null;
	    };
	    ContextNode.ρAnn = function () {
	        return { "name": "ContextNode" };
	    };
	    return ContextNode;
	}(ioc.Destoryable));
	exports.ContextNode = ContextNode;
	exports.CONTEXT_REF = ioc.tokenId('CONTEXT_REF');
	exports.ELEMENT_REF = ioc.tokenId('ELEMENT_REF');
	exports.NATIVE_ELEMENT = ioc.tokenId('NATIVE_ELEMENT');
	exports.TEMPLATE_REF = ioc.tokenId('TEMPLATE_REF');
	exports.ROOT_NODES = ioc.tokenId('ROOT_NODES');
	exports.REFCHILD_SELECTOR = ioc.tokenId('REFCHILD_SELECTOR');
	exports.COMPONENT_REF = ioc.tokenId('COMPONENT_REF');
	exports.COMPONENT_TYPE = ioc.tokenId('COMPONENT_TYPE');
	exports.COMPONENT_INST = ioc.tokenId('COMPONENT_INST');
	var NodeRef = /** @class */ (function (_super) {
	    tslib.__extends(NodeRef, _super);
	    function NodeRef(context, nodes) {
	        var _this = _super.call(this, context) || this;
	        _this._rootNodes = nodes;
	        return _this;
	    }
	    Object.defineProperty(NodeRef.prototype, "rootNodes", {
	        get: function () {
	            return this._rootNodes;
	        },
	        enumerable: false,
	        configurable: true
	    });
	    NodeRef.prototype.destroying = function () {
	        this.rootNodes
	            .forEach(function (node) {
	            if (node && ioc.isFunction(node.destroy)) {
	                node.destroy();
	            }
	        });
	        this._rootNodes = [];
	        _super.prototype.destroying.call(this);
	    };
	    NodeRef.ρAnn = function () {
	        return { "name": "NodeRef" };
	    };
	    NodeRef = tslib.__decorate([
	        tslib.__param(0, ioc.Inject(exports.CONTEXT_REF)),
	        tslib.__param(1, ioc.Inject(exports.ROOT_NODES)),
	        tslib.__metadata("design:paramtypes", [Object, Array])
	    ], NodeRef);
	    return NodeRef;
	}(ContextNode));
	exports.NodeRef = NodeRef;
	var ElementRef = /** @class */ (function (_super) {
	    tslib.__extends(ElementRef, _super);
	    function ElementRef(context, nativeElement) {
	        var _this = _super.call(this, context) || this;
	        _this.nativeElement = nativeElement;
	        var injector = context.injector;
	        if (!injector.has(exports.ELEMENT_REFS)) {
	            injector.setValue(exports.ELEMENT_REFS, new WeakMap());
	        }
	        injector.getValue(exports.ELEMENT_REFS).set(nativeElement, _this);
	        _this.onDestroy(function () { var _a; return (_a = injector.getValue(exports.ELEMENT_REFS)) === null || _a === void 0 ? void 0 : _a.delete(nativeElement); });
	        return _this;
	    }
	    ElementRef.prototype.destroying = function () {
	        var element = this.nativeElement;
	        if (element && ioc.isFunction(element.destroy)) {
	            element.destroy();
	        }
	        _super.prototype.destroying.call(this);
	    };
	    ElementRef.ρAnn = function () {
	        return { "name": "ElementRef", "params": { "constructor": ["context", "nativeElement"] } };
	    };
	    ElementRef = tslib.__decorate([
	        ioc.Injectable,
	        tslib.__param(0, ioc.Inject(exports.CONTEXT_REF)),
	        tslib.__param(1, ioc.Inject(exports.NATIVE_ELEMENT)),
	        tslib.__metadata("design:paramtypes", [Object, Object])
	    ], ElementRef);
	    return ElementRef;
	}(ContextNode));
	exports.ElementRef = ElementRef;
	var TemplateRef = /** @class */ (function (_super) {
	    tslib.__extends(TemplateRef, _super);
	    function TemplateRef() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(TemplateRef.prototype, "template", {
	        get: function () {
	            return this.context.getValue(boot.CTX_TEMPLATE);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    TemplateRef.ρAnn = function () {
	        return { "name": "TemplateRef", "params": {} };
	    };
	    TemplateRef = tslib.__decorate([
	        ioc.Injectable
	    ], TemplateRef);
	    return TemplateRef;
	}(NodeRef));
	exports.TemplateRef = TemplateRef;
	var ComponentRef = /** @class */ (function (_super) {
	    tslib.__extends(ComponentRef, _super);
	    function ComponentRef(componentType, instance, context, nodeRef) {
	        var _this = _super.call(this, context) || this;
	        _this.componentType = componentType;
	        _this.instance = instance;
	        _this.nodeRef = nodeRef;
	        if (!context.injector.has(exports.COMPONENT_REFS)) {
	            context.injector.setValue(exports.COMPONENT_REFS, new WeakMap());
	        }
	        var injector = context.injector;
	        injector.getValue(exports.COMPONENT_REFS).set(instance, _this);
	        _this.onDestroy(function () { var _a; return (_a = injector.getValue(exports.COMPONENT_REFS)) === null || _a === void 0 ? void 0 : _a.delete(_this.instance); });
	        return _this;
	    }
	    Object.defineProperty(ComponentRef.prototype, "selector", {
	        get: function () {
	            return this.context.getValue(exports.REFCHILD_SELECTOR);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ComponentRef.prototype.getNodeSelector = function () {
	        return new NodeSelector(this.nodeRef);
	    };
	    ComponentRef.prototype.destroying = function () {
	        this.nodeRef.destroy();
	        _super.prototype.destroying.call(this);
	    };
	    ComponentRef.ρAnn = function () {
	        return { "name": "ComponentRef", "params": { "constructor": ["componentType", "instance", "context", "nodeRef"] } };
	    };
	    ComponentRef = tslib.__decorate([
	        ioc.Injectable,
	        tslib.__param(0, ioc.Inject(exports.COMPONENT_TYPE)),
	        tslib.__param(1, ioc.Inject(exports.COMPONENT_INST)),
	        tslib.__param(2, ioc.Inject(exports.CONTEXT_REF)),
	        tslib.__param(3, ioc.Inject(exports.TEMPLATE_REF)),
	        tslib.__metadata("design:paramtypes", [Object, Object, Object, Object])
	    ], ComponentRef);
	    return ComponentRef;
	}(ContextNode));
	exports.ComponentRef = ComponentRef;
	/**
	 * node selector.
	 *
	 * @export
	 * @abstract
	 * @class NodeSelector
	 * @template T
	 */
	var NodeSelector = /** @class */ (function () {
	    function NodeSelector(node) {
	        this.node = node;
	    }
	    NodeSelector.prototype.find = function (express, mode) {
	        var component;
	        this.each(function (item) {
	            if (component) {
	                return false;
	            }
	            var isFinded = ioc.isFunction(express) ? express(item) : item === express;
	            if (isFinded) {
	                component = item;
	                return false;
	            }
	            return true;
	        }, mode);
	        return component;
	    };
	    NodeSelector.prototype.filter = function (express, mode) {
	        var nodes = [];
	        this.each(function (item) {
	            if (express(item)) {
	                nodes.push(item);
	            }
	        }, mode);
	        return nodes;
	    };
	    NodeSelector.prototype.map = function (express, mode) {
	        var nodes = [];
	        this.each(function (item) {
	            var r = express(item);
	            if (ioc.isBoolean(r)) {
	                return r;
	            }
	            else if (r) {
	                nodes.push(r);
	            }
	        }, mode);
	        return nodes;
	    };
	    NodeSelector.prototype.each = function (express, mode) {
	        // mode = mode || 'traverse';
	        var r;
	        switch (mode) {
	            case 'route':
	                r = this.routeUp(this.node, express);
	                break;
	            case 'children':
	                r = this.eachChildren(this.node, express);
	                break;
	            case 'traverseLast':
	                r = this.transAfter(this.node, express);
	                break;
	            case 'traverse':
	            default:
	                r = this.trans(this.node, express);
	                break;
	        }
	        return r;
	    };
	    NodeSelector.prototype.eachChildren = function (node, express) {
	        var _this = this;
	        this.getChildren(node).some(function (item) { return _this.currNode(item, express) === false; });
	    };
	    /**
	     *do express work in routing.
	     *
	     *@param {Express<T, void | boolean>} express
	     *
	     *@memberOf IComponent
	     */
	    NodeSelector.prototype.routeUp = function (node, express) {
	        if (!node) {
	            return true;
	        }
	        if (this.currNode(node, express) === false) {
	            return false;
	        }
	        var parentNode = this.getParent(node);
	        if (parentNode) {
	            return this.routeUp(parentNode, express);
	        }
	    };
	    /**
	     *translate all sub context to do express work.
	     *
	     *@param {Express<IComponent, void | boolean>} express
	     *
	     *@memberOf IComponent
	     */
	    NodeSelector.prototype.trans = function (node, express) {
	        var _this = this;
	        if (!node) {
	            return true;
	        }
	        if (this.currNode(node, express) === false) {
	            return false;
	        }
	        var children = this.getChildren(node);
	        if (children.some(function (r) { return _this.trans(r, express) === false; })) {
	            return false;
	        }
	        return true;
	    };
	    NodeSelector.prototype.transAfter = function (node, express) {
	        var _this = this;
	        if (!node) {
	            return true;
	        }
	        var children = this.getChildren(node);
	        if (children.some(function (r) { return _this.transAfter(r, express) === false; })) {
	            return false;
	        }
	        if (this.currNode(node, express) === false) {
	            return false;
	        }
	        return true;
	    };
	    NodeSelector.prototype.currNode = function (node, express) {
	        var _this = this;
	        var roots = node.rootNodes;
	        if (roots.some(function (n) {
	            if (n instanceof NodeRef) {
	                return _this.currNode(n, express);
	            }
	            else if (n instanceof ComponentRef) {
	                if (express(n) === false) {
	                    return true;
	                }
	                return _this.currNode(n.nodeRef, express);
	            }
	            else if (n instanceof ElementRef) {
	                return express(n.nativeElement) === false;
	            }
	            return express(n) === false;
	        })) {
	            return false;
	        }
	    };
	    NodeSelector.prototype.getParent = function (node) {
	        var parent = node.context.getParent();
	        if (parent && parent.hasValue(NodeRef)) {
	            return parent.getValue(NodeRef);
	        }
	        return null;
	    };
	    NodeSelector.prototype.getChildren = function (node) {
	        var ctx = node.context;
	        if (ctx.hasChildren()) {
	            return ctx.getChildren().map(function (c) { return c.getValue(NodeRef); });
	        }
	        return [];
	    };
	    NodeSelector.ρAnn = function () {
	        return { "name": "NodeSelector" };
	    };
	    return NodeSelector;
	}());
	exports.NodeSelector = NodeSelector;
	var NullSelector = /** @class */ (function (_super) {
	    tslib.__extends(NullSelector, _super);
	    function NullSelector() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    NullSelector.prototype.getParent = function (node) {
	        return null;
	    };
	    NullSelector.prototype.getChildren = function (node) {
	        return [];
	    };
	    NullSelector.ρAnn = function () {
	        return { "name": "NullSelector" };
	    };
	    return NullSelector;
	}(NodeSelector));
	exports.NullSelector = NullSelector;


	});

	unwrapExports(ComponentRef_1);
	var ComponentRef_2 = ComponentRef_1.NullSelector;
	var ComponentRef_3 = ComponentRef_1.NodeSelector;
	var ComponentRef_4 = ComponentRef_1.ComponentRef;
	var ComponentRef_5 = ComponentRef_1.TemplateRef;
	var ComponentRef_6 = ComponentRef_1.ElementRef;
	var ComponentRef_7 = ComponentRef_1.NodeRef;
	var ComponentRef_8 = ComponentRef_1.COMPONENT_INST;
	var ComponentRef_9 = ComponentRef_1.COMPONENT_TYPE;
	var ComponentRef_10 = ComponentRef_1.COMPONENT_REF;
	var ComponentRef_11 = ComponentRef_1.REFCHILD_SELECTOR;
	var ComponentRef_12 = ComponentRef_1.ROOT_NODES;
	var ComponentRef_13 = ComponentRef_1.TEMPLATE_REF;
	var ComponentRef_14 = ComponentRef_1.NATIVE_ELEMENT;
	var ComponentRef_15 = ComponentRef_1.ELEMENT_REF;
	var ComponentRef_16 = ComponentRef_1.CONTEXT_REF;
	var ComponentRef_17 = ComponentRef_1.ContextNode;
	var ComponentRef_18 = ComponentRef_1.ELEMENT_REFS;
	var ComponentRef_19 = ComponentRef_1.COMPONENT_REFS;
	var ComponentRef_20 = ComponentRef_1.CTX_COMPONENT_REF;
	var ComponentRef_21 = ComponentRef_1.CTX_TEMPLATE_SCOPE;
	var ComponentRef_22 = ComponentRef_1.CTX_TEMPLATE_REF;
	var ComponentRef_23 = ComponentRef_1.CTX_ELEMENT_REF;
	var ComponentRef_24 = ComponentRef_1.CTX_COMPONENT;
	var ComponentRef_25 = ComponentRef_1.CTX_COMPONENT_DECTOR;

	var ComponentProvider_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AstResolver = exports.ComponentProvider = exports.CTX_COMPONENT_PROVIDER = void 0;




	var attrSelPrefix = /^ATTR__/;
	var seletPrefix = /^SELTR_/;
	exports.CTX_COMPONENT_PROVIDER = ioc.tokenId('CTX_COMPONENT_PROVIDER');
	/**
	 * ref element identfy selector.
	 *
	 * @export
	 * @abstract
	 * @class RefIdentfy
	 */
	var ComponentProvider = /** @class */ (function () {
	    function ComponentProvider(dectorator) {
	        this.dectorator = dectorator;
	        /**
	         * parse element, template as ref or not.
	         */
	        this.parseRef = false;
	    }
	    ComponentProvider.prototype.getProviders = function () {
	        if (!this.providers) {
	            this.providers = this.reflects.getActionInjector().get(ioc.DecoratorProvider).getProviders(this.dectorator);
	        }
	        return this.providers;
	    };
	    ComponentProvider.prototype.createNodeSelector = function (element) {
	        var _a, _b, _c, _d;
	        return (_d = (_c = (_b = (_a = this.reflects.get(ioc.lang.getClass(element))) === null || _a === void 0 ? void 0 : _a.getInjector()) === null || _b === void 0 ? void 0 : _b.getValue(ComponentRef_1.COMPONENT_REFS)) === null || _c === void 0 ? void 0 : _c.get(element)) === null || _d === void 0 ? void 0 : _d.getNodeSelector();
	    };
	    ComponentProvider.prototype.getAstResolver = function () {
	        var _a;
	        if (!this.ast) {
	            this.ast = (_a = this.getProviders().getInstance(AstResolver)) !== null && _a !== void 0 ? _a : this.reflects.getContainer().getInstance(AstResolver);
	        }
	        return this.ast;
	    };
	    ComponentProvider.prototype.isTemplate = function (target) {
	        return ioc.isMetadataObject(target, this.getSelectorKey());
	    };
	    ComponentProvider.prototype.createComponentRef = function (type, target, context) {
	        var nodes = [];
	        for (var _i = 3; _i < arguments.length; _i++) {
	            nodes[_i - 3] = arguments[_i];
	        }
	        return this.getProviders().getInstance(ComponentRef_1.COMPONENT_REF, { provide: ComponentRef_1.CONTEXT_REF, useValue: context }, { provide: ComponentRef_1.COMPONENT_TYPE, useValue: type }, { provide: ComponentRef_1.COMPONENT_INST, useValue: target }, { provide: ComponentRef_1.TEMPLATE_REF, useValue: this.createTemplateRef.apply(this, tslib.__spreadArrays([context], nodes)) });
	    };
	    ComponentProvider.prototype.createTemplateRef = function (context) {
	        var nodes = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            nodes[_i - 1] = arguments[_i];
	        }
	        return this.getProviders().getInstance(ComponentRef_1.TEMPLATE_REF, { provide: ComponentRef_1.CONTEXT_REF, useValue: context }, { provide: ComponentRef_1.ROOT_NODES, useValue: nodes });
	    };
	    ComponentProvider.prototype.createElementRef = function (context, target) {
	        return this.getProviders().getInstance(ComponentRef_1.ELEMENT_REF, { provide: ComponentRef_1.CONTEXT_REF, useValue: context }, { provide: ComponentRef_1.NATIVE_ELEMENT, useValue: target });
	    };
	    ComponentProvider.prototype.getElementRef = function (target, injector) {
	        var _a;
	        injector = injector !== null && injector !== void 0 ? injector : this.reflects.get(ioc.lang.getClass(target)).getInjector();
	        return (_a = injector.getValue(ComponentRef_1.ELEMENT_REFS)) === null || _a === void 0 ? void 0 : _a.get(target);
	    };
	    ComponentProvider.prototype.getComponentRef = function (target, injector) {
	        var _a;
	        injector = injector !== null && injector !== void 0 ? injector : this.reflects.get(ioc.lang.getClass(target)).getInjector();
	        return (_a = injector.getValue(ComponentRef_1.COMPONENT_REFS)) === null || _a === void 0 ? void 0 : _a.get(target);
	    };
	    ComponentProvider.prototype.getPipe = function (token, injector) {
	        return injector.get(token);
	    };
	    ComponentProvider.prototype.toSelectorToken = function (selector) {
	        return seletPrefix.test(selector) ? selector : "SELTR_" + selector;
	    };
	    ComponentProvider.prototype.toAttrSelectorToken = function (selector) {
	        return attrSelPrefix.test(selector) ? selector : "ATTR_" + selector;
	    };
	    /**
	     * bind function context.
	     * @param func func
	     * @param ctx context to bind.
	     */
	    ComponentProvider.prototype.bindContext = function (func, ctx) {
	        var bindFunc = func;
	        if (!bindFunc.__binded) {
	            bindFunc = function () {
	                var args = [];
	                for (var _i = 0; _i < arguments.length; _i++) {
	                    args[_i] = arguments[_i];
	                }
	                return func.apply(void 0, tslib.__spreadArrays(args, [ctx]));
	            };
	            bindFunc.__binded = true;
	        }
	        return bindFunc;
	    };
	    /**
	     * select ref tag in element.
	     *
	     * @param {*} element
	     * @param {(string | ((e: any) => boolean))} selector
	     * @returns {*}
	     * @memberof RefSelector
	     */
	    ComponentProvider.prototype.select = function (element, selector) {
	        var _this = this;
	        var selFunc;
	        if (ioc.isString(selector)) {
	            var idkey_1 = this.getRefSelectKey();
	            selFunc = function (e) { return _this.match(e, selector, idkey_1); };
	        }
	        else {
	            selFunc = selector;
	        }
	        var cmpSelector = this.isComponentRef(element) ? element.getNodeSelector() : this.createNodeSelector(element);
	        if (cmpSelector) {
	            return cmpSelector.find(function (e) { return selFunc(e); });
	        }
	        return null;
	    };
	    ComponentProvider.prototype.match = function (e, selector, idkey) {
	        if (this.isComponentRef(e)) {
	            return e.selector === selector;
	        }
	        return e[idkey] === selector;
	    };
	    ComponentProvider.prototype.isNodeType = function (element) {
	        return this.isComponentType(element) || this.isElementType(element);
	    };
	    ComponentProvider.prototype.isComponentType = function (element) {
	        var _a;
	        return ioc.isClass(element) && ((_a = this.reflects.get(element)) === null || _a === void 0 ? void 0 : _a.component);
	    };
	    ComponentProvider.ρAnn = function () {
	        return { "name": "ComponentProvider", "params": { "constructor": ["dectorator"], "createNodeSelector": ["element"], "isTemplate": ["target"], "createComponentRef": ["type", "target", "context", "nodes"], "isTemplateContext": ["context"], "createTemplateContext": ["injector", "options"], "createTemplateRef": ["context", "nodes"], "createElementRef": ["context", "target"], "getElementRef": ["target", "injector"], "getComponentRef": ["target", "injector"], "getPipe": ["token", "injector"], "toSelectorToken": ["selector"], "toAttrSelectorToken": ["selector"], "bindContext": ["func", "ctx"], "select": ["element", "selector"], "match": ["e", "selector", "idkey"], "isElementRef": ["target"], "isComponentRef": ["target"], "isElementRefType": ["target"], "isComponentRefType": ["target"], "isNodeType": ["element"], "isComponentType": ["element"], "isElementType": ["element"] } };
	    };
	    tslib.__decorate([
	        ioc.Inject(ioc.TypeReflectsToken),
	        tslib.__metadata("design:type", Object)
	    ], ComponentProvider.prototype, "reflects", void 0);
	    ComponentProvider = tslib.__decorate([
	        ioc.Abstract(),
	        tslib.__param(0, ioc.Inject(ioc.DECORATOR)),
	        tslib.__metadata("design:paramtypes", [String])
	    ], ComponentProvider);
	    return ComponentProvider;
	}());
	exports.ComponentProvider = ComponentProvider;
	var AstResolver = /** @class */ (function () {
	    function AstResolver(provider) {
	        this.provider = provider;
	    }
	    /**
	     * resolve expression.
	     *
	     * @param {string} expression
	     * @param {ICoreInjector} [injector]
	     * @param {Object | Map<string, any>} [scope]
	     * @param {*} [envOptions]
	     * @returns {*}
	     * @memberof AstResolver
	     */
	    AstResolver.prototype.resolve = function (expression, injector, scope, envOptions) {
	        if (!expression) {
	            return expression;
	        }
	        try {
	            // xxx | pipename
	            var pipes = void 0;
	            var map = this.parseScope(expression, scope, envOptions);
	            var idx = expression.search(exps.pipeExp);
	            if (idx > 0) {
	                pipes = expression.substring(idx + 3).split(' | ');
	                expression = expression.substring(0, idx);
	            }
	            var value_1 = this.eval(expression, map);
	            if (pipes && pipes.length) {
	                var scopes = Array.from(map.keys());
	                var args_1 = Array.from(map.values());
	                this.transforms(pipes, injector, scopes)
	                    .forEach(function (tsf) {
	                    value_1 = tsf(value_1, args_1, envOptions);
	                });
	            }
	            return value_1;
	        }
	        catch (err) {
	            return void 0;
	        }
	    };
	    AstResolver.prototype.parse = function (expression, injector) {
	        var _this = this;
	        if (!expression) {
	            return null;
	        }
	        var self = this;
	        return (function () {
	            var pipes;
	            var map;
	            var scopes;
	            var transforms;
	            var expFunc;
	            return function (scope, envOptions) {
	                try {
	                    // xxx | pipename
	                    if (!map || !expFunc) {
	                        map = self.parseScope(expression, scope, envOptions);
	                        scopes = Array.from(map.keys());
	                        var idx = expression.search(exps.pipeExp);
	                        if (idx > 0) {
	                            pipes = expression.substring(idx + 3).split(' | ');
	                            expression = expression.substring(0, idx);
	                        }
	                        if (pipes) {
	                            transforms = _this.transforms(pipes, injector, scopes);
	                        }
	                        expFunc = _this.toScopFunc(expression, scopes);
	                    }
	                    var args_2 = Array.from(scope.values());
	                    var value_2 = expFunc.apply(void 0, args_2);
	                    if (transforms && transforms.length) {
	                        transforms.forEach(function (tsf) {
	                            value_2 = tsf(value_2, args_2, envOptions);
	                        });
	                    }
	                    return value_2;
	                }
	                catch (err) {
	                    return void 0;
	                }
	            };
	        })();
	    };
	    AstResolver.prototype.parseScope = function (expression, scope, envOptions) {
	        if (scope) {
	            if (scope instanceof Map) {
	                return scope;
	            }
	            var map_1 = new Map();
	            Object.keys(scope).forEach(function (k) {
	                if (expression.indexOf(k) >= 0) {
	                    map_1.set(k, scope[k]);
	                }
	            });
	            if (ioc.isTypeObject(scope)) {
	                var descps_1 = this.provider.reflects.create(ioc.lang.getClass(scope)).defines.getPropertyDescriptors();
	                Object.keys(descps_1).forEach(function (k) {
	                    if (k === 'constructor' || expression.indexOf(k) < 0) {
	                        return;
	                    }
	                    var val;
	                    var de = descps_1[k];
	                    if (ioc.isFunction(de.value)) {
	                        val = function () {
	                            var args = [];
	                            for (var _i = 0; _i < arguments.length; _i++) {
	                                args[_i] = arguments[_i];
	                            }
	                            return scope[k].apply(scope, args);
	                        };
	                    }
	                    else {
	                        val = scope[k];
	                    }
	                    if (ioc.isDefined(val)) {
	                        map_1.set(k, val);
	                    }
	                });
	            }
	            if (envOptions) {
	                Object.keys(envOptions).forEach(function (k) {
	                    if (expression.indexOf(k) >= 0) {
	                        map_1.set(k, envOptions[k]);
	                    }
	                });
	            }
	            return map_1;
	        }
	        return null;
	    };
	    AstResolver.prototype.eval = function (expression, scopes) {
	        if (scopes) {
	            var func = this.toScopFunc(expression, Array.from(scopes.keys()));
	            return func.apply(void 0, Array.from(scopes.values()));
	        }
	        else {
	            return this.toScopFunc(expression, [])();
	        }
	    };
	    AstResolver.prototype.toScopFunc = function (expression, scopes) {
	        return new (Function.bind.apply(Function, tslib.__spreadArrays([void 0], scopes, ["return " + expression])))();
	    };
	    AstResolver.prototype.transforms = function (pipes, injector, scopes) {
	        var _this = this;
	        return pipes.map(function (p) {
	            var _a = p.split(':'), pipeName = _a[0], args = _a[1];
	            var pipe = _this.provider.getPipe(pipeName, injector);
	            var pipeAg;
	            var isArray;
	            if (args) {
	                if (args.indexOf(',') > 0) {
	                    pipeAg = _this.toScopFunc("[" + args + "]", scopes);
	                    isArray = true;
	                }
	                else {
	                    pipeAg = _this.toScopFunc(args, scopes);
	                }
	            }
	            return pipeAg ? function (value, args, envOptions) { return pipe.transform.apply(pipe, tslib.__spreadArrays([value], (isArray ? pipeAg.apply(void 0, args) : [pipeAg.apply(void 0, args)]), [envOptions])); }
	                : function (value, args, envOptions) { return pipe.transform(value, envOptions); };
	        });
	    };
	    AstResolver.ρAnn = function () {
	        return { "name": "AstResolver", "params": { "constructor": ["provider"], "resolve": ["expression", "injector", "scope", "envOptions"], "parse": ["expression", "injector"], "parseScope": ["expression", "scope", "envOptions"], "eval": ["expression", "scopes"], "toScopFunc": ["expression", "scopes"], "transforms": ["pipes", "injector", "scopes"] } };
	    };
	    AstResolver = tslib.__decorate([
	        ioc.Injectable(),
	        tslib.__metadata("design:paramtypes", [ComponentProvider])
	    ], AstResolver);
	    return AstResolver;
	}());
	exports.AstResolver = AstResolver;


	});

	unwrapExports(ComponentProvider_1);
	var ComponentProvider_2 = ComponentProvider_1.AstResolver;
	var ComponentProvider_3 = ComponentProvider_1.ComponentProvider;
	var ComponentProvider_4 = ComponentProvider_1.CTX_COMPONENT_PROVIDER;

	var ElementNode_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ElementNode = void 0;



	/**
	 * Element node.
	 *
	 * @export
	 * @class ElementNode
	 * @extends {CompositeNode}
	 */
	var ElementNode = /** @class */ (function () {
	    function ElementNode() {
	    }
	    /**
	     * is equals or not.
	     *
	     * @param {ElementNode} node
	     * @param {ElementNode} [node2]
	     * @returns {boolean}
	     * @memberof ElementNode
	     */
	    ElementNode.prototype.equals = function (node, node2) {
	        return node === (node2 || this);
	    };
	    ElementNode.ρAnn = function () {
	        return { "name": "ElementNode", "params": { "equals": ["node", "node2"] } };
	    };
	    ElementNode.classType = 'directive';
	    tslib.__decorate([
	        Input.Input(),
	        tslib.__metadata("design:type", String)
	    ], ElementNode.prototype, "id", void 0);
	    tslib.__decorate([
	        Input.Input(),
	        tslib.__metadata("design:type", String)
	    ], ElementNode.prototype, "selector", void 0);
	    tslib.__decorate([
	        Input.Input(),
	        tslib.__metadata("design:type", String)
	    ], ElementNode.prototype, "name", void 0);
	    ElementNode = tslib.__decorate([
	        Component.Component()
	    ], ElementNode);
	    return ElementNode;
	}());
	exports.ElementNode = ElementNode;


	});

	unwrapExports(ElementNode_1);
	var ElementNode_2 = ElementNode_1.ElementNode;

	var ComponentContext_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentContext = exports.CTX_COMPONENT_CONTEXT = void 0;





	exports.CTX_COMPONENT_CONTEXT = ioc.tokenId('CTX_COMPONENT_CONTEXT');
	var ComponentContext = /** @class */ (function (_super) {
	    tslib.__extends(ComponentContext, _super);
	    function ComponentContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    Object.defineProperty(ComponentContext.prototype, "name", {
	        get: function () {
	            return this.context.getValue(boot.CTX_ELEMENT_NAME);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ComponentContext.prototype.getResultRef = function () {
	        var _a;
	        return (_a = this.context.getFirstValue(ComponentRef_1.CTX_COMPONENT_REF, ComponentRef_1.CTX_TEMPLATE_REF, ComponentRef_1.CTX_ELEMENT_REF)) !== null && _a !== void 0 ? _a : this.value;
	    };
	    ComponentContext.prototype.getTargetReflect = function () {
	        return _super.prototype.getTargetReflect.call(this);
	    };
	    /**
	     * annoation metadata.
	     */
	    ComponentContext.prototype.getAnnoation = function () {
	        return _super.prototype.getAnnoation.call(this);
	    };
	    /**
	     * component instance.
	     *
	     * @readonly
	     * @type {*}
	     * @memberof ComponentContext
	     */
	    ComponentContext.prototype.getComponent = function () {
	        var _this = this;
	        var _a, _b;
	        return (_a = this.context.getValue(ComponentRef_1.CTX_COMPONENT)) !== null && _a !== void 0 ? _a : (_b = this.getParent()) === null || _b === void 0 ? void 0 : _b.getContextValue(ComponentRef_1.CTX_COMPONENT, function (com) { return _this.setValue(ComponentRef_1.CTX_COMPONENT, com); });
	    };
	    ComponentContext.prototype.getComponentContext = function () {
	        var _this = this;
	        var _a, _b;
	        return ((_a = this.context.getValue(exports.CTX_COMPONENT_CONTEXT)) !== null && _a !== void 0 ? _a : (_b = this.getParent()) === null || _b === void 0 ? void 0 : _b.getContextValue(exports.CTX_COMPONENT_CONTEXT, function (ctx) { return _this.setValue(exports.CTX_COMPONENT_CONTEXT, ctx); }));
	    };
	    /**
	     * template scope.
	     *
	     * @readonly
	     * @memberof ComponentContext
	     */
	    ComponentContext.prototype.getScope = function () {
	        var _this = this;
	        var _a, _b;
	        return (_a = this.context.getValue(ComponentRef_1.CTX_TEMPLATE_SCOPE)) !== null && _a !== void 0 ? _a : (_b = this.getParent()) === null || _b === void 0 ? void 0 : _b.getContextValue(ComponentRef_1.CTX_TEMPLATE_SCOPE, function (scope) { return _this.setValue(ComponentRef_1.CTX_TEMPLATE_SCOPE, scope); });
	    };
	    ComponentContext.prototype.getScopes = function () {
	        var scopes = [];
	        var ctx = this.getComponentContext();
	        while (ctx && !ctx.destroyed) {
	            var comp = ctx.getValue(ComponentRef_1.CTX_COMPONENT);
	            if (comp) {
	                scopes.push(comp);
	            }
	            ctx = ctx.getComponentContext();
	        }
	        return scopes;
	    };
	    Object.defineProperty(ComponentContext.prototype, "componentProvider", {
	        get: function () {
	            var _a;
	            return (_a = this.context.getValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER)) !== null && _a !== void 0 ? _a : this.getComponentProvider();
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ComponentContext.prototype.getComponentProvider = function () {
	        var dector = this.componentDecorator;
	        var pdr = dector ? this.reflects.getActionInjector().getInstance(ioc.DecoratorProvider).resolve(dector, ComponentProvider_1.ComponentProvider) : null;
	        pdr && this.setValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER, pdr);
	        return pdr;
	    };
	    Object.defineProperty(ComponentContext.prototype, "componentDecorator", {
	        get: function () {
	            var _this = this;
	            var _a, _b;
	            return (_a = this.context.getValue(ComponentRef_1.CTX_COMPONENT_DECTOR)) !== null && _a !== void 0 ? _a : (_b = this.getParent()) === null || _b === void 0 ? void 0 : _b.getContextValue(ComponentRef_1.CTX_COMPONENT_DECTOR, function (dector) { return _this.setValue(ComponentRef_1.CTX_COMPONENT_DECTOR, dector); });
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ComponentContext.ρAnn = function () {
	        return { "name": "ComponentContext" };
	    };
	    return ComponentContext;
	}(boot.BuildContext));
	exports.ComponentContext = ComponentContext;


	});

	unwrapExports(ComponentContext_1);
	var ComponentContext_2 = ComponentContext_1.ComponentContext;
	var ComponentContext_3 = ComponentContext_1.CTX_COMPONENT_CONTEXT;

	var TemplateContext_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.TemplateContext = exports.TemplateOptionToken = void 0;




	/**
	 * Template option token.
	 */
	exports.TemplateOptionToken = ioc.tokenId('COMPONENT_TEMPLATE_OPTION');
	/**
	 * template context.
	 *
	 * @export
	 * @class TemplateContext
	 * @extends {IocRaiseContext<IContainer>}
	 * @implements {IComponentContext}
	 */
	var TemplateContext = /** @class */ (function (_super) {
	    tslib.__extends(TemplateContext, _super);
	    function TemplateContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TemplateContext_1 = TemplateContext;
	    TemplateContext.parse = function (injector, options) {
	        return boot.createContext(injector, TemplateContext_1, options);
	    };
	    TemplateContext.ρAnn = function () {
	        return { "name": "TemplateContext", "params": { "parse": ["injector", "options"] } };
	    };
	    var TemplateContext_1;
	    TemplateContext = TemplateContext_1 = tslib.__decorate([
	        ioc.Injectable
	    ], TemplateContext);
	    return TemplateContext;
	}(ComponentContext_1.ComponentContext));
	exports.TemplateContext = TemplateContext;


	});

	unwrapExports(TemplateContext_1);
	var TemplateContext_2 = TemplateContext_1.TemplateContext;
	var TemplateContext_3 = TemplateContext_1.TemplateOptionToken;

	var ElementProvider_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ElementProvider = void 0;






	/**
	 * ref element selector.
	 *
	 * @export
	 * @class RefElementSelector
	 * @extends {ComponentProvider}
	 */
	var ElementProvider = /** @class */ (function (_super) {
	    tslib.__extends(ElementProvider, _super);
	    function ElementProvider() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ElementProvider.prototype.isElementRef = function (target) {
	        return target instanceof ComponentRef_1.ElementRef;
	    };
	    ElementProvider.prototype.isComponentRef = function (target) {
	        return target instanceof ComponentRef_1.ComponentRef;
	    };
	    ElementProvider.prototype.isElementRefType = function (target) {
	        return target === ComponentRef_1.ElementRef;
	    };
	    ElementProvider.prototype.isComponentRefType = function (target) {
	        return target === ComponentRef_1.ComponentRef;
	    };
	    ElementProvider.prototype.isElementType = function (element) {
	        return (element === null || element === void 0 ? void 0 : element.ρCT) === 'directive';
	    };
	    ElementProvider.prototype.isTemplateContext = function (context) {
	        return context instanceof TemplateContext_1.TemplateContext;
	    };
	    ElementProvider.prototype.createTemplateContext = function (injector, options) {
	        return TemplateContext_1.TemplateContext.parse(injector, options);
	    };
	    ElementProvider.prototype.getDefaultCompose = function () {
	        return ElementNode_1.ElementNode;
	    };
	    ElementProvider.prototype.getSelectorKey = function () {
	        return 'element';
	    };
	    ElementProvider.prototype.getRefSelectKey = function () {
	        return 'selector';
	    };
	    ElementProvider.ρAnn = function () {
	        return { "name": "ElementProvider", "params": { "isElementRef": ["target"], "isComponentRef": ["target"], "isElementRefType": ["target"], "isComponentRefType": ["target"], "isElementType": ["element"], "isTemplateContext": ["context"], "createTemplateContext": ["injector", "options"] } };
	    };
	    ElementProvider = tslib.__decorate([
	        ioc.Singleton()
	    ], ElementProvider);
	    return ElementProvider;
	}(ComponentProvider_1.ComponentProvider));
	exports.ElementProvider = ElementProvider;


	});

	unwrapExports(ElementProvider_1);
	var ElementProvider_2 = ElementProvider_1.ElementProvider;

	var ElementModule_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ElementModule = void 0;









	/**
	 * component element module.
	 *
	 * @export
	 * @class ElementModule
	 */
	var ElementModule = /** @class */ (function () {
	    function ElementModule() {
	    }
	    ElementModule.prototype.setup = function (container) {
	        var actInjector = container.getActionInjector();
	        actInjector.getInstance(boot.StartupDecoratorRegisterer)
	            .register(Component.Component, 'TranslateTemplate', ComponentSelectorHandle_1.ComponentSelectorHandle);
	        actInjector.regAction(ComponentSelectorHandle_1.ComponentSelectorHandle);
	        actInjector.getInstance(ioc.DecoratorProvider)
	            .bindProviders(Component.Component, { provide: ComponentProvider_1.ComponentProvider, useClass: ElementProvider_1.ElementProvider });
	        container.registerType(ElementNode_1.ElementNode);
	    };
	    ElementModule.ρAnn = function () {
	        return { "name": "ElementModule", "params": { "setup": ["container"] } };
	    };
	    tslib.__decorate([
	        tslib.__param(0, ioc.Inject(core.ContainerToken)),
	        tslib.__metadata("design:type", Function),
	        tslib.__metadata("design:paramtypes", [Object]),
	        tslib.__metadata("design:returntype", void 0)
	    ], ElementModule.prototype, "setup", null);
	    ElementModule = tslib.__decorate([
	        ioc.IocExt(),
	        tslib.__metadata("design:paramtypes", [])
	    ], ElementModule);
	    return ElementModule;
	}());
	exports.ElementModule = ElementModule;


	});

	unwrapExports(ElementModule_1);
	var ElementModule_2 = ElementModule_1.ElementModule;

	var elements = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	// handles
	tslib.__exportStar(ComponentSelectorHandle_1, exports);
	tslib.__exportStar(ElementProvider_1, exports);
	tslib.__exportStar(ElementModule_1, exports);
	tslib.__exportStar(ElementNode_1, exports);


	});

	unwrapExports(elements);

	var ParseContext_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParseContext = exports.CTX_BIND_PARSED = exports.CTX_BIND_EXPRESSION = exports.CTX_BIND_BINDING = exports.CTX_BIND_DATABINDING = void 0;







	exports.CTX_BIND_DATABINDING = ioc.tokenId('CTX_BIND_DATABINDING');
	exports.CTX_BIND_BINDING = ioc.tokenId('CTX_BIND_BINDING');
	exports.CTX_BIND_EXPRESSION = ioc.tokenId('CTX_BIND_EXPRESSION');
	exports.CTX_BIND_PARSED = ioc.tokenId('CTX_BIND_PARSED');
	var inputDect = Input.Input.toString();
	var outputDect = Output.Output.toString();
	var refDect = RefChild.RefChild.toString();
	/**
	 * parse context.
	 *
	 * @export
	 * @class ParseContext
	 * @extends {BuildContext}
	 * @implements {IComponentContext}
	 */
	var ParseContext = /** @class */ (function (_super) {
	    tslib.__extends(ParseContext, _super);
	    function ParseContext() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ParseContext_1 = ParseContext;
	    Object.defineProperty(ParseContext.prototype, "binding", {
	        get: function () {
	            return this.getValue(exports.CTX_BIND_BINDING);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ParseContext.prototype, "bindExpression", {
	        get: function () {
	            return this.getValue(exports.CTX_BIND_EXPRESSION);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    Object.defineProperty(ParseContext.prototype, "dataBinding", {
	        get: function () {
	            return this.getValue(exports.CTX_BIND_DATABINDING);
	        },
	        enumerable: false,
	        configurable: true
	    });
	    ParseContext.prototype.getExtenalBindings = function () {
	        var _a, _b, _c, _d, _e, _f;
	        var parent = this.getParent();
	        if (parent) {
	            var template = parent.getTemplate();
	            var targetReflect = parent.getTargetReflect();
	            if (template && targetReflect) {
	                return ioc.lang.omit.apply(ioc.lang, tslib.__spreadArrays([template], Array.from((_b = (_a = targetReflect.getBindings(inputDect)) === null || _a === void 0 ? void 0 : _a.keys()) !== null && _b !== void 0 ? _b : []), Array.from((_d = (_c = targetReflect.getBindings(outputDect)) === null || _c === void 0 ? void 0 : _c.keys()) !== null && _d !== void 0 ? _d : []), Array.from((_f = (_e = targetReflect.getBindings(refDect)) === null || _e === void 0 ? void 0 : _e.keys()) !== null && _f !== void 0 ? _f : [])));
	            }
	        }
	        return {};
	    };
	    ParseContext.prototype.setOptions = function (options) {
	        if (!options) {
	            return this;
	        }
	        if (options.binding) {
	            this.setValue(exports.CTX_BIND_BINDING, options.binding);
	        }
	        if (ioc.isDefined(options.bindExpression)) {
	            this.setValue(exports.CTX_BIND_EXPRESSION, options.bindExpression);
	        }
	        return _super.prototype.setOptions.call(this, options);
	    };
	    ParseContext.parse = function (injector, options) {
	        return boot.createContext(injector, ParseContext_1, options);
	    };
	    ParseContext.ρAnn = function () {
	        return { "name": "ParseContext", "params": { "setOptions": ["options"], "parse": ["injector", "options"] } };
	    };
	    var ParseContext_1;
	    ParseContext = ParseContext_1 = tslib.__decorate([
	        ioc.Injectable
	    ], ParseContext);
	    return ParseContext;
	}(ComponentContext_1.ComponentContext));
	exports.ParseContext = ParseContext;


	});

	unwrapExports(ParseContext_1);
	var ParseContext_2 = ParseContext_1.ParseContext;
	var ParseContext_3 = ParseContext_1.CTX_BIND_PARSED;
	var ParseContext_4 = ParseContext_1.CTX_BIND_EXPRESSION;
	var ParseContext_5 = ParseContext_1.CTX_BIND_BINDING;
	var ParseContext_6 = ParseContext_1.CTX_BIND_DATABINDING;

	var IComponentReflect = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.DefaultComponets = void 0;

	/**
	 * default components.
	 */
	exports.DefaultComponets = ioc.tokenId('DefaultComponets');


	});

	unwrapExports(IComponentReflect);
	var IComponentReflect_1 = IComponentReflect.DefaultComponets;

	var IComponentBuilder = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentBuilderToken = void 0;

	/**
	 * component build token.
	 */
	exports.ComponentBuilderToken = ioc.tokenId('ComponentBuilder');


	});

	unwrapExports(IComponentBuilder);
	var IComponentBuilder_1 = IComponentBuilder.ComponentBuilderToken;

	var parseTempl = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParseSelectorHandle = exports.TranslateElementHandle = exports.TranslateSelectorScope = exports.ElementsTemplateHandle = exports.TemplateParseScope = void 0;








	/**
	 * template parse scope.
	 *
	 * @export
	 * @class TemplateParseScope
	 * @extends {TemplatesHandle}
	 */
	var TemplateParseScope = /** @class */ (function (_super) {
	    tslib.__extends(TemplateParseScope, _super);
	    function TemplateParseScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TemplateParseScope.prototype.execute = function (ctx, next) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
	                    case 1:
	                        _a.sent();
	                        if (!next) return [3 /*break*/, 3];
	                        return [4 /*yield*/, next()];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3:
	                        // after all clean.
	                        if (ioc.isNullOrUndefined(ctx.value)) {
	                            setTimeout(function () { return ctx.destroy(); });
	                        }
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    TemplateParseScope.prototype.setup = function () {
	        this.use(exports.ElementsTemplateHandle)
	            .use(TranslateSelectorScope)
	            .use(exports.ParseSelectorHandle);
	    };
	    TemplateParseScope.ρAnn = function () {
	        return { "name": "TemplateParseScope" };
	    };
	    return TemplateParseScope;
	}(boot.BuildHandles));
	exports.TemplateParseScope = TemplateParseScope;
	/**
	 * elements template handle.
	 *
	 * @export
	 * @class ElementsTemplateHandle
	 * @extends {TemplateHandle}
	 */
	exports.ElementsTemplateHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var template, actInjector_1, _a;
	        var _this = this;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    template = ctx.getTemplate();
	                    if (!ioc.isArray(template)) return [3 /*break*/, 2];
	                    actInjector_1 = ctx.reflects.getActionInjector();
	                    _a = ctx;
	                    return [4 /*yield*/, Promise.all(template.filter(function (e) { return ioc.isDefined(e); }).map(function (tp) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var subCtx;
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        subCtx = ctx.clone().setOptions({
	                                            template: tp
	                                        });
	                                        return [4 /*yield*/, actInjector_1.getInstance(TemplateParseScope).execute(subCtx)];
	                                    case 1:
	                                        _a.sent();
	                                        if (ioc.isNullOrUndefined(subCtx.value)) {
	                                            return [2 /*return*/, tp];
	                                        }
	                                        else {
	                                            if (!ctx.hasValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER)) {
	                                                ctx.setValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER, subCtx.componentProvider);
	                                            }
	                                            return [2 /*return*/, subCtx.value];
	                                        }
	                                }
	                            });
	                        }); }))];
	                case 1:
	                    _a.value = _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _b.sent();
	                    _b.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * translate selector scope.
	 *
	 * @export
	 * @class TranslateSelectorScope
	 * @extends {TemplatesHandle}
	 */
	var TranslateSelectorScope = /** @class */ (function (_super) {
	    tslib.__extends(TranslateSelectorScope, _super);
	    function TranslateSelectorScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    TranslateSelectorScope.prototype.execute = function (ctx, next) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
	                    case 1:
	                        _a.sent();
	                        if (!next) return [3 /*break*/, 3];
	                        return [4 /*yield*/, next()];
	                    case 2:
	                        _a.sent();
	                        _a.label = 3;
	                    case 3: return [2 /*return*/];
	                }
	            });
	        });
	    };
	    TranslateSelectorScope.prototype.setup = function () {
	        this.use(exports.TranslateElementHandle);
	    };
	    TranslateSelectorScope.ρAnn = function () {
	        return { "name": "TranslateSelectorScope" };
	    };
	    return TranslateSelectorScope;
	}(boot.BuildHandles));
	exports.TranslateSelectorScope = TranslateSelectorScope;
	/**
	 * translate element handle.
	 *
	 * @export
	 * @class TranslateElementHandle
	 * @extends {TemplateHandle}
	 */
	exports.TranslateElementHandle = function (ctx, next) {
	    var _a, _b;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var actInjector, reg, decorators;
	        var _this = this;
	        return tslib.__generator(this, function (_c) {
	            switch (_c.label) {
	                case 0:
	                    actInjector = ctx.reflects.getActionInjector();
	                    reg = actInjector.getInstance(boot.StartupDecoratorRegisterer).getRegisterer('TranslateTemplate');
	                    if (!ctx.componentDecorator) return [3 /*break*/, 3];
	                    if (!reg.has(ctx.componentDecorator)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, ioc.chain(reg.getFuncs(actInjector, ctx.componentDecorator), ctx)];
	                case 1:
	                    _c.sent();
	                    _c.label = 2;
	                case 2: return [3 /*break*/, 5];
	                case 3:
	                    decorators = (_b = (_a = ctx.getModuleRef()) === null || _a === void 0 ? void 0 : _a.reflect.componentDectors) !== null && _b !== void 0 ? _b : actInjector.getValue(IComponentReflect.DefaultComponets);
	                    return [4 /*yield*/, ioc.chain(decorators.map(function (decor) { return function (ctx, next) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        if (!reg.has(decor)) return [3 /*break*/, 2];
	                                        ctx.remove(ComponentProvider_1.CTX_COMPONENT_PROVIDER);
	                                        ctx.setValue(ComponentRef_1.CTX_COMPONENT_DECTOR, decor);
	                                        return [4 /*yield*/, ioc.chain(reg.getFuncs(actInjector, decor), ctx)];
	                                    case 1:
	                                        _a.sent();
	                                        _a.label = 2;
	                                    case 2:
	                                        if (!!ctx.selector) return [3 /*break*/, 4];
	                                        return [4 /*yield*/, next()];
	                                    case 3:
	                                        _a.sent();
	                                        _a.label = 4;
	                                    case 4: return [2 /*return*/];
	                                }
	                            });
	                        }); }; }), ctx)];
	                case 4:
	                    _c.sent();
	                    _c.label = 5;
	                case 5:
	                    if (!!ctx.selector) return [3 /*break*/, 7];
	                    return [4 /*yield*/, next()];
	                case 6:
	                    _c.sent();
	                    _c.label = 7;
	                case 7: return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * parse selector handle.
	 *
	 * @export
	 * @class ParseSelectorHandle
	 * @extends {ParsersHandle}
	 */
	exports.ParseSelectorHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var selector, template, compCtx;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    if (!ctx.selector) return [3 /*break*/, 2];
	                    selector = ctx.selector;
	                    template = ctx.getTemplate();
	                    return [4 /*yield*/, ctx.getContainer().getInstance(IComponentBuilder.ComponentBuilderToken)
	                            .build({
	                            type: selector,
	                            parent: ctx,
	                            sub: true,
	                            template: template,
	                            providers: ctx.providers.inject({ provide: TemplateContext_1.TemplateOptionToken, useValue: ctx.getOptions() })
	                        })];
	                case 1:
	                    compCtx = _a.sent();
	                    if (compCtx.value) {
	                        if (!ctx.hasValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER)) {
	                            ctx.setValue(ComponentProvider_1.CTX_COMPONENT_PROVIDER, compCtx.componentProvider);
	                        }
	                        ctx.value = compCtx.value;
	                    }
	                    _a.label = 2;
	                case 2:
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};


	});

	unwrapExports(parseTempl);
	var parseTempl_1 = parseTempl.ParseSelectorHandle;
	var parseTempl_2 = parseTempl.TranslateElementHandle;
	var parseTempl_3 = parseTempl.TranslateSelectorScope;
	var parseTempl_4 = parseTempl.ElementsTemplateHandle;
	var parseTempl_5 = parseTempl.TemplateParseScope;

	var bindingComp = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AssignDefaultValueHandle = exports.AssignBindValueHandle = exports.TranslateAtrrHandle = exports.TranslateExpressionHandle = exports.BindingScopeHandle = exports.BindingValueScope = exports.BindingArrayHandle = exports.BindingScope = void 0;











	/**
	 * binding scope.
	 *
	 * @export
	 * @class BindingScope
	 * @extends {ParsersHandle}
	 */
	var BindingScope = /** @class */ (function (_super) {
	    tslib.__extends(BindingScope, _super);
	    function BindingScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BindingScope.prototype.execute = function (ctx, next) {
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0:
	                        if (!ctx.hasValue(ParseContext_1.CTX_BIND_BINDING)) return [3 /*break*/, 2];
	                        return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
	                    case 1:
	                        _a.sent();
	                        _a.label = 2;
	                    case 2:
	                        if (!next) return [3 /*break*/, 4];
	                        return [4 /*yield*/, next()];
	                    case 3:
	                        _a.sent();
	                        _a.label = 4;
	                    case 4:
	                        // after all clean.
	                        setTimeout(function () { return ctx.destroy(); });
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    BindingScope.prototype.setup = function () {
	        this.use(exports.BindingArrayHandle)
	            .use(BindingValueScope);
	    };
	    BindingScope.ρAnn = function () {
	        return { "name": "BindingScope" };
	    };
	    return BindingScope;
	}(boot.BuildHandles));
	exports.BindingScope = BindingScope;
	/**
	 * binding array handle.
	 *
	 * @export
	 * @class BindingArrayHandle
	 * @extends {ParseHandle}
	 */
	exports.BindingArrayHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var binding, expression, actInjector_1, _a;
	        var _this = this;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    binding = ctx.getValue(ParseContext_1.CTX_BIND_BINDING);
	                    expression = ctx.getValue(ParseContext_1.CTX_BIND_EXPRESSION);
	                    if (!(binding.type === Array && ioc.isArray(expression))) return [3 /*break*/, 2];
	                    actInjector_1 = ctx.reflects.getActionInjector();
	                    _a = ctx;
	                    return [4 /*yield*/, Promise.all(expression.filter(function (e) { return ioc.isDefined(e); }).map(function (tp) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var subCtx;
	                            var _a;
	                            return tslib.__generator(this, function (_b) {
	                                switch (_b.label) {
	                                    case 0:
	                                        subCtx = ctx.clone().setOptions({
	                                            bindExpression: tp,
	                                            template: tp,
	                                            sub: true
	                                        });
	                                        return [4 /*yield*/, actInjector_1.getInstance(BindingScope).execute(subCtx)];
	                                    case 1:
	                                        _b.sent();
	                                        return [2 /*return*/, (_a = subCtx.value) !== null && _a !== void 0 ? _a : tp];
	                                }
	                            });
	                        }); }))];
	                case 1:
	                    _a.value = _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _b.sent();
	                    _b.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * binding value scope.
	 *
	 * @export
	 * @class BindingValueScope
	 * @extends {ParsersHandle}
	 */
	var BindingValueScope = /** @class */ (function (_super) {
	    tslib.__extends(BindingValueScope, _super);
	    function BindingValueScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BindingValueScope.prototype.setup = function () {
	        this.use(exports.BindingScopeHandle)
	            .use(exports.TranslateExpressionHandle)
	            .use(exports.TranslateAtrrHandle)
	            .use(exports.AssignBindValueHandle)
	            .use(exports.AssignDefaultValueHandle);
	    };
	    BindingValueScope.ρAnn = function () {
	        return { "name": "BindingValueScope" };
	    };
	    return BindingValueScope;
	}(boot.BuildHandles));
	exports.BindingValueScope = BindingValueScope;
	var bindPref = 'binding:';
	var twobindPref = 'binding=:';
	var two2bindPref = '[(binding)]:';
	var eventBindPref = '(binding):';
	/**
	 * binding scope handle.
	 *
	 * @export
	 * @class BindingScopeHandle
	 * @extends {ParseHandle}
	 */
	exports.BindingScopeHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var expression, binding, actInjector, regs, compdect, exp, dataBinding_1, dataBinding;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    expression = ctx.bindExpression;
	                    if (!ctx.hasValue(ParseContext_1.CTX_BIND_DATABINDING) && expression instanceof PropBinding_1.PropBinding) {
	                        ctx.setValue(ParseContext_1.CTX_BIND_DATABINDING, expression);
	                    }
	                    binding = ctx.binding;
	                    if (!(!ctx.hasValue(ParseContext_1.CTX_BIND_DATABINDING) && ioc.isString(expression))) return [3 /*break*/, 3];
	                    actInjector = ctx.reflects.getActionInjector();
	                    regs = actInjector.getInstance(boot.StartupDecoratorRegisterer)
	                        .getRegisterer('BindExpression');
	                    compdect = ctx.componentDecorator;
	                    if (!regs.has(compdect)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, ioc.chain(regs.getFuncs(actInjector, compdect), ctx)];
	                case 1:
	                    _a.sent();
	                    return [3 /*break*/, 3];
	                case 2:
	                    exp = expression.trim();
	                    if (binding.direction === 'input') {
	                        if (exp.startsWith(bindPref)) {
	                            dataBinding_1 = new OneWayBinding_1.OneWayBinding(ctx.injector, ctx.componentProvider, ctx.getScope(), binding, exp.replace(bindPref, '').trim());
	                        }
	                        else if (exp.startsWith(twobindPref)) {
	                            dataBinding_1 = new TwoWayBinding_1.TwoWayBinding(ctx.injector, ctx.componentProvider, ctx.getScope(), binding, exp.replace(twobindPref, '').trim());
	                        }
	                        else if (exp.startsWith(two2bindPref)) {
	                            dataBinding_1 = new TwoWayBinding_1.TwoWayBinding(ctx.injector, ctx.componentProvider, ctx.getScope(), binding, exp.replace(two2bindPref, '').trim());
	                        }
	                    }
	                    else if (binding.direction === 'output' && exp.startsWith(eventBindPref)) {
	                        dataBinding_1 = new EventBinding_1.EventBinding(ctx.injector, ctx.componentProvider, ctx.getScope(), binding, exp.replace(eventBindPref, '').trim());
	                    }
	                    dataBinding_1 && ctx.setValue(ParseContext_1.CTX_BIND_DATABINDING, dataBinding_1);
	                    _a.label = 3;
	                case 3:
	                    dataBinding = ctx.dataBinding;
	                    if (dataBinding instanceof ParseBinding_1.ParseBinding) {
	                        ctx.setValue(ParseContext_1.CTX_BIND_EXPRESSION, dataBinding.resolveExression());
	                    }
	                    else if (dataBinding instanceof PropBinding_1.PropBinding) {
	                        ctx.value = dataBinding.resolveExression();
	                    }
	                    if (!(next && ioc.isNullOrUndefined(ctx.value))) return [3 /*break*/, 5];
	                    return [4 /*yield*/, next()];
	                case 4:
	                    _a.sent();
	                    _a.label = 5;
	                case 5: return [2 /*return*/];
	            }
	        });
	    });
	};
	exports.TranslateExpressionHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var expression, binding, componentProvider, tpCtx, type, sub;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    expression = ctx.bindExpression;
	                    binding = ctx.binding;
	                    componentProvider = ctx.componentProvider;
	                    if (!componentProvider.isTemplate(expression)) return [3 /*break*/, 2];
	                    tpCtx = componentProvider.createTemplateContext(ctx.injector, {
	                        parent: ctx.getComponentContext(),
	                        template: expression,
	                        providers: ctx.providers
	                    });
	                    return [4 /*yield*/, ctx.reflects.getActionInjector()
	                            .getInstance(parseTempl.TemplateParseScope)
	                            .execute(tpCtx)];
	                case 1:
	                    _a.sent();
	                    if (!tpCtx.destroyed) {
	                        ctx.setValue(ParseContext_1.CTX_BIND_PARSED, !!tpCtx.value);
	                        type = ioc.lang.getClass(tpCtx.value);
	                        sub = ctx.getOptions().sub;
	                        if ((sub && (!binding.provider || ctx.reflects.isExtends(type, binding.provider)))
	                            || (!sub && ctx.reflects.isExtends(type, binding.type))) {
	                            ctx.value = tpCtx.value;
	                        }
	                        else {
	                            ctx.setValue(ParseContext_1.CTX_BIND_EXPRESSION, tpCtx.value);
	                        }
	                    }
	                    _a.label = 2;
	                case 2:
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * translate attr hanlde.
	 *
	 * @export
	 * @class TranslateAtrrHandle
	 * @extends {ParseHandle}
	 */
	exports.TranslateAtrrHandle = function (ctx, next) {
	    var _a, _b;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var expression, binding, injector, pdr, selector, reflects, compdr, bindings, _c;
	        return tslib.__generator(this, function (_d) {
	            switch (_d.label) {
	                case 0:
	                    expression = ctx.bindExpression;
	                    binding = ctx.binding;
	                    if (!!ioc.isNullOrUndefined(expression)) return [3 /*break*/, 2];
	                    injector = ctx.injector;
	                    pdr = binding.provider;
	                    selector = void 0;
	                    reflects = ctx.reflects;
	                    compdr = ctx.componentProvider;
	                    if (ioc.isString(pdr) && compdr && injector.hasRegister(compdr.toAttrSelectorToken(pdr))) {
	                        selector = injector.getTokenProvider(compdr.toAttrSelectorToken(pdr));
	                    }
	                    else if (binding.type !== Array) {
	                        if (ioc.isClassType(binding.provider)) {
	                            if ((_a = reflects.get(binding.provider)) === null || _a === void 0 ? void 0 : _a.component) {
	                                selector = binding.provider;
	                            }
	                        }
	                        if (!selector && ioc.isClassType(binding.type)) {
	                            if ((_b = reflects.get(binding.type)) === null || _b === void 0 ? void 0 : _b.component) {
	                                selector = binding.type;
	                            }
	                        }
	                    }
	                    if (!selector) return [3 /*break*/, 2];
	                    bindings = ctx.getExtenalBindings();
	                    bindings[binding.bindingName || binding.name] = expression;
	                    _c = ctx;
	                    return [4 /*yield*/, injector.getInstance(IComponentBuilder.ComponentBuilderToken).resolve({
	                            type: selector,
	                            attr: true,
	                            parent: ctx.getComponentContext(),
	                            template: bindings,
	                            providers: ctx.providers
	                        })];
	                case 1:
	                    _c.value = _d.sent();
	                    ctx.setValue(ParseContext_1.CTX_BIND_PARSED, !!ctx.value);
	                    _d.label = 2;
	                case 2:
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _d.sent();
	                    _d.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	exports.AssignBindValueHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var expression, binding, type, ttype;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    expression = ctx.bindExpression;
	                    binding = ctx.binding;
	                    if (!ioc.isNullOrUndefined(expression)) {
	                        type = binding.type;
	                        if (ioc.isBaseType(type)) {
	                            if (ioc.isFunction(expression)) {
	                                ctx.value = ioc.isClassType(expression) ? expression : ctx.componentProvider.bindContext(expression, ctx.getComponentContext());
	                            }
	                            else {
	                                ctx.value = ctx.injector.getInstance(boot.BaseTypeParser).parse(type, expression);
	                            }
	                        }
	                        else if (ioc.isClassType(type)) {
	                            ttype = ioc.lang.getClass(expression);
	                            if (ctx.reflects.isExtends(ttype, type)) {
	                                ctx.value = expression;
	                            }
	                        }
	                        else {
	                            if (ioc.isFunction(expression) && !ioc.isClassType(expression)) {
	                                ctx.value = ctx.componentProvider.bindContext(expression, ctx.getComponentContext());
	                            }
	                            else {
	                                ctx.value = expression;
	                            }
	                        }
	                    }
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, next()];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2: return [2 /*return*/];
	            }
	        });
	    });
	};
	exports.AssignDefaultValueHandle = function (ctx, next) {
	    var _a;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    ctx.value = (_a = ctx.binding) === null || _a === void 0 ? void 0 : _a.defaultValue;
	                    if (!ioc.isNullOrUndefined(ctx.value)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, next()];
	                case 1:
	                    _b.sent();
	                    _b.label = 2;
	                case 2: return [2 /*return*/];
	            }
	        });
	    });
	};


	});

	unwrapExports(bindingComp);
	var bindingComp_1 = bindingComp.AssignDefaultValueHandle;
	var bindingComp_2 = bindingComp.AssignBindValueHandle;
	var bindingComp_3 = bindingComp.TranslateAtrrHandle;
	var bindingComp_4 = bindingComp.TranslateExpressionHandle;
	var bindingComp_5 = bindingComp.BindingScopeHandle;
	var bindingComp_6 = bindingComp.BindingValueScope;
	var bindingComp_7 = bindingComp.BindingArrayHandle;
	var bindingComp_8 = bindingComp.BindingScope;

	var buildComp = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ParseTemplateHandle = exports.ModuleAfterContentInitHandle = exports.BindingOutputHandle = exports.BindingTemplateRefHandle = exports.ValifyTeamplateHandle = exports.ResolveTemplateHanlde = exports.ResolveTargetRefScope = exports.ModuleAfterInitHandle = exports.ModuleInitHandle = exports.BindingPropertyHandle = exports.ModuleBeforeInitHandle = exports.BindingComponentScope = void 0;















	var binding_comp_2 = bindingComp;

	var BindingComponentScope = /** @class */ (function (_super) {
	    tslib.__extends(BindingComponentScope, _super);
	    function BindingComponentScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    BindingComponentScope.prototype.execute = function (ctx, next) {
	        var _a, _b;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var refl, cmpRef, mdref, componentDectors, decorPdr_1;
	            return tslib.__generator(this, function (_c) {
	                switch (_c.label) {
	                    case 0:
	                        refl = ctx.getTargetReflect();
	                        if (refl === null || refl === void 0 ? void 0 : refl.getModuleRef) {
	                            setTimeout(function () { return ctx.destroy(); });
	                            return [2 /*return*/];
	                        }
	                        if (!ctx.value) {
	                            return [2 /*return*/, next()];
	                        }
	                        cmpRef = refl;
	                        if (!(cmpRef === null || cmpRef === void 0 ? void 0 : cmpRef.component)) return [3 /*break*/, 4];
	                        if (!!(ctx instanceof ComponentContext_1.ComponentContext)) return [3 /*break*/, 1];
	                        throw Error("Component decorator '" + ctx.decorator + "' is not provide component builder");
	                    case 1:
	                        ctx.setValue(ComponentRef_1.CTX_COMPONENT_DECTOR, ctx.decorator);
	                        ctx.setValue(ComponentRef_1.CTX_COMPONENT, ctx.value);
	                        ctx.setValue(ComponentContext_1.CTX_COMPONENT_CONTEXT, ctx);
	                        (_a = ctx.getParent()) === null || _a === void 0 ? void 0 : _a.addChild(ctx);
	                        return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
	                    case 2:
	                        _c.sent();
	                        _c.label = 3;
	                    case 3: return [3 /*break*/, 5];
	                    case 4:
	                        if (!ctx.getOptions().attr) {
	                            mdref = ctx.getModuleRef();
	                            if (mdref && mdref.reflect.componentDectors) {
	                                componentDectors = mdref.reflect.componentDectors;
	                                decorPdr_1 = ctx.reflects.getActionInjector().getInstance(ioc.DecoratorProvider);
	                                componentDectors.some(function (decor) {
	                                    var refSelector = decorPdr_1.resolve(decor, ComponentProvider_1.ComponentProvider);
	                                    if (refSelector.parseRef && (refSelector === null || refSelector === void 0 ? void 0 : refSelector.isElementType(ctx.type))) {
	                                        var elRef = refSelector.createElementRef(ctx, ctx.value);
	                                        ctx.setValue(ComponentRef_1.CTX_ELEMENT_REF, elRef);
	                                        return true;
	                                    }
	                                    return false;
	                                });
	                            }
	                            if (ctx.hasValue(ComponentRef_1.CTX_ELEMENT_REF)) {
	                                (_b = ctx.getParent()) === null || _b === void 0 ? void 0 : _b.addChild(ctx);
	                                ctx.value = ctx.getValue(ComponentRef_1.CTX_ELEMENT_REF);
	                            }
	                            else {
	                                setTimeout(function () { return ctx.destroy(); });
	                            }
	                        }
	                        _c.label = 5;
	                    case 5: return [2 /*return*/, next()];
	                }
	            });
	        });
	    };
	    BindingComponentScope.prototype.setup = function () {
	        this.use(exports.ModuleBeforeInitHandle)
	            .use(exports.BindingPropertyHandle)
	            .use(exports.ModuleInitHandle)
	            .use(exports.ModuleAfterInitHandle)
	            .use(ResolveTargetRefScope)
	            .use(exports.BindingOutputHandle)
	            .use(exports.ModuleAfterContentInitHandle);
	    };
	    BindingComponentScope.ρAnn = function () {
	        return { "name": "BindingComponentScope" };
	    };
	    return BindingComponentScope;
	}(boot.BuildHandles));
	exports.BindingComponentScope = BindingComponentScope;
	/**
	 * module before init handle
	 *
	 * @export
	 * @class ModuleBeforeInitHandle
	 * @extends {ResolveComponentHandle}
	 */
	exports.ModuleBeforeInitHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var target;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    target = ctx.value;
	                    if (!(target && ioc.isFunction(target.onBeforeInit))) return [3 /*break*/, 2];
	                    return [4 /*yield*/, target.onBeforeInit()];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	var inputDector = Input.Input.toString();
	/**
	 * binding property handle.
	 *
	 * @export
	 * @class BindingPropertyHandle
	 * @extends {ResolveHandle}
	 */
	exports.BindingPropertyHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var refl, propInBindings, bindings_1, actInjector_1;
	        var _this = this;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    refl = ctx.getTargetReflect();
	                    propInBindings = refl === null || refl === void 0 ? void 0 : refl.getBindings(inputDector);
	                    if (!propInBindings) return [3 /*break*/, 2];
	                    bindings_1 = ctx.getTemplate();
	                    actInjector_1 = ctx.reflects.getActionInjector();
	                    return [4 /*yield*/, Promise.all(Array.from(propInBindings.keys()).map(function (n) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var binding, filed, expression, pctx_1, bvailds;
	                            var _this = this;
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        binding = propInBindings.get(n);
	                                        filed = binding.bindingName || binding.name;
	                                        expression = bindings_1 ? bindings_1[filed] : null;
	                                        if (!ioc.isDefined(expression)) return [3 /*break*/, 4];
	                                        if (!(binding.bindingType === 'dynamic')) return [3 /*break*/, 1];
	                                        ctx.value[binding.name] = expression;
	                                        return [3 /*break*/, 3];
	                                    case 1:
	                                        pctx_1 = ParseContext_1.ParseContext.parse(ctx.injector, {
	                                            type: ctx.type,
	                                            parent: ctx,
	                                            bindExpression: expression,
	                                            binding: binding
	                                        });
	                                        return [4 /*yield*/, actInjector_1.getInstance(bindingComp.BindingScope).execute(pctx_1, function () { return tslib.__awaiter(_this, void 0, void 0, function () {
	                                                return tslib.__generator(this, function (_a) {
	                                                    if (pctx_1.dataBinding instanceof ParseBinding_1.ParseBinding) {
	                                                        if (pctx_1.getValue(ParseContext_1.CTX_BIND_PARSED) && ioc.isTypeObject(pctx_1.value)) {
	                                                            ctx.value[binding.name] = pctx_1.value;
	                                                            pctx_1.dataBinding.bind(pctx_1.value);
	                                                        }
	                                                        else {
	                                                            pctx_1.dataBinding.bind(ctx.value, pctx_1.value);
	                                                        }
	                                                    }
	                                                    else if (pctx_1.dataBinding instanceof PropBinding_1.PropBinding) {
	                                                        pctx_1.dataBinding.bind(ctx.value, pctx_1.value);
	                                                    }
	                                                    else {
	                                                        ctx.value[binding.name] = pctx_1.value;
	                                                    }
	                                                    return [2 /*return*/];
	                                                });
	                                            }); })];
	                                    case 2:
	                                        _a.sent();
	                                        _a.label = 3;
	                                    case 3: return [3 /*break*/, 5];
	                                    case 4:
	                                        if (ioc.isDefined(binding.defaultValue)) {
	                                            ctx.value[binding.name] = binding.defaultValue;
	                                        }
	                                        _a.label = 5;
	                                    case 5:
	                                        bvailds = refl === null || refl === void 0 ? void 0 : refl.getBindings(Vaildate.Vaildate.toString()).get(binding.name);
	                                        if (!(bvailds && bvailds.length)) return [3 /*break*/, 7];
	                                        return [4 /*yield*/, Promise.all(bvailds.map(function (bvaild) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                                                var vaild;
	                                                return tslib.__generator(this, function (_a) {
	                                                    switch (_a.label) {
	                                                        case 0:
	                                                            if (bvaild.required && ioc.isDefined(ctx.value[binding.name])) {
	                                                                throw new Error(ioc.lang.getClassName(ctx.value) + "." + binding.name + " is not vaild. " + bvaild.errorMsg);
	                                                            }
	                                                            if (!bvaild.vaild) return [3 /*break*/, 2];
	                                                            return [4 /*yield*/, bvaild.vaild(ctx.value[binding.name], ctx.value)];
	                                                        case 1:
	                                                            vaild = _a.sent();
	                                                            if (!vaild) {
	                                                                throw new Error(ioc.lang.getClassName(ctx.value) + "." + binding.name + " is not vaild. " + bvaild.errorMsg);
	                                                            }
	                                                            _a.label = 2;
	                                                        case 2: return [2 /*return*/];
	                                                    }
	                                                });
	                                            }); }))];
	                                    case 6:
	                                        _a.sent();
	                                        _a.label = 7;
	                                    case 7: return [2 /*return*/];
	                                }
	                            });
	                        }); }))];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2: return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * module init handle.
	 *
	 * @export
	 * @class ModuleAfterInitHandle
	 * @extends {ResolveHandle}
	 */
	exports.ModuleInitHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var target;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    target = ctx.value;
	                    if (!(target && ioc.isFunction(target.onInit))) return [3 /*break*/, 2];
	                    return [4 /*yield*/, target.onInit()];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * module after init handle.
	 *
	 * @export
	 * @class ModuleAfterInitHandle
	 * @extends {ResolveHandle}
	 */
	exports.ModuleAfterInitHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var target;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    target = ctx.value;
	                    if (!(target && ioc.isFunction(target.onAfterInit))) return [3 /*break*/, 2];
	                    return [4 /*yield*/, target.onAfterInit()];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	var ResolveTargetRefScope = /** @class */ (function (_super) {
	    tslib.__extends(ResolveTargetRefScope, _super);
	    function ResolveTargetRefScope() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    ResolveTargetRefScope.prototype.execute = function (ctx, next) {
	        var _a;
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var annoation, refl, compdr, elRef;
	            return tslib.__generator(this, function (_b) {
	                switch (_b.label) {
	                    case 0:
	                        annoation = ctx.getAnnoation();
	                        if (!ctx.getOptions().attr) return [3 /*break*/, 3];
	                        if (!annoation.template) return [3 /*break*/, 1];
	                        throw new Error('template component can not set as attr of oathor component');
	                    case 1: return [4 /*yield*/, next()];
	                    case 2: return [2 /*return*/, _b.sent()];
	                    case 3:
	                        if (!annoation.template) return [3 /*break*/, 5];
	                        return [4 /*yield*/, _super.prototype.execute.call(this, ctx)];
	                    case 4:
	                        _b.sent();
	                        ctx.value = ctx.getValue(ComponentRef_1.CTX_COMPONENT_REF);
	                        return [3 /*break*/, 6];
	                    case 5:
	                        refl = ctx.getTargetReflect();
	                        compdr = refl.getDecorProviders().getInstance(ComponentProvider_1.ComponentProvider);
	                        if (compdr.parseRef && (compdr === null || compdr === void 0 ? void 0 : compdr.isElementType(ctx.type))) {
	                            elRef = compdr.createElementRef(ctx, ctx.value);
	                            ctx.setValue(ComponentRef_1.CTX_ELEMENT_REF, elRef);
	                            ctx.value = elRef;
	                        }
	                        // is not compoent or element.
	                        if (!ctx.hasValue(ComponentRef_1.CTX_ELEMENT_REF)) {
	                            (_a = ctx.getParent()) === null || _a === void 0 ? void 0 : _a.removeChild(ctx);
	                            ctx.setParent(null);
	                        }
	                        _b.label = 6;
	                    case 6: return [4 /*yield*/, next()];
	                    case 7:
	                        _b.sent();
	                        return [2 /*return*/];
	                }
	            });
	        });
	    };
	    ResolveTargetRefScope.prototype.setup = function () {
	        this.use(exports.ResolveTemplateHanlde)
	            .use(exports.ValifyTeamplateHandle)
	            .use(exports.BindingTemplateRefHandle);
	    };
	    ResolveTargetRefScope.ρAnn = function () {
	        return { "name": "ResolveTargetRefScope" };
	    };
	    return ResolveTargetRefScope;
	}(boot.BuildHandles));
	exports.ResolveTargetRefScope = ResolveTargetRefScope;
	function cloneTemplate(target) {
	    if (ioc.isArray(target)) {
	        return target.map(function (it) { return cloneTemplate(it); });
	    }
	    if (ioc.isFunction(target)) {
	        return target;
	    }
	    else if (ioc.isMetadataObject(target)) {
	        var newM_1 = {};
	        ioc.lang.forIn(target, function (val, name) {
	            newM_1[name] = cloneTemplate(val);
	        });
	        return newM_1;
	    }
	    else if (ioc.isBaseValue(target)) {
	        return target;
	    }
	    return null;
	}
	exports.ResolveTemplateHanlde = function (ctx, next) {
	    var _a;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var actInjector, compPdr, pCtx;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    actInjector = ctx.reflects.getActionInjector();
	                    compPdr = ctx.componentProvider;
	                    pCtx = compPdr.createTemplateContext(ctx.injector, {
	                        parent: ctx,
	                        template: cloneTemplate(ctx.getAnnoation().template)
	                    });
	                    pCtx.setValue(ComponentRef_1.CTX_TEMPLATE_SCOPE, ctx.value);
	                    return [4 /*yield*/, actInjector.getInstance(parseTempl.TemplateParseScope)
	                            .execute(pCtx)];
	                case 1:
	                    _b.sent();
	                    if (!pCtx.value) return [3 /*break*/, 3];
	                    ctx.setValue(ComponentRef_1.CTX_COMPONENT_REF, ioc.isArray(pCtx.value) ? compPdr.createComponentRef.apply(compPdr, tslib.__spreadArrays([ctx.type, ctx.value, ctx], pCtx.value)) : compPdr.createComponentRef(ctx.type, ctx.value, ctx, pCtx.value));
	                    return [4 /*yield*/, next()];
	                case 2:
	                    _b.sent();
	                    return [3 /*break*/, 4];
	                case 3:
	                    (_a = ctx.getParent()) === null || _a === void 0 ? void 0 : _a.removeChild(ctx);
	                    ctx.remove(ComponentRef_1.CTX_COMPONENT);
	                    _b.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	exports.ValifyTeamplateHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var actInjector, startupRegr, validRegs;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    actInjector = ctx.reflects.getActionInjector();
	                    startupRegr = actInjector.getInstance(boot.StartupDecoratorRegisterer);
	                    validRegs = startupRegr.getRegisterer('ValifyComponent');
	                    if (!validRegs.has(ctx.decorator)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, ioc.chain(validRegs.getFuncs(actInjector, ctx.decorator), ctx)];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	var RefChildStr = RefChild.RefChild.toString();
	/**
	 * binding temlpate handle.
	 *
	 * @export
	 * @class BindingTemplateHandle
	 * @extends {ResolveHandle}
	 */
	exports.BindingTemplateRefHandle = function (ctx, next) {
	    var _a;
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var refl, cmpdr, refkey, propRefChildBindings, cref_1, actInjector, startupRegr, bindRegs;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    refl = ctx.getTargetReflect();
	                    cmpdr = ctx.componentProvider;
	                    refkey = (_a = ctx.getTemplate()) === null || _a === void 0 ? void 0 : _a[cmpdr.getRefSelectKey()];
	                    if (refkey) {
	                        ctx.setValue(ComponentRef_1.REFCHILD_SELECTOR, refkey);
	                    }
	                    propRefChildBindings = refl === null || refl === void 0 ? void 0 : refl.getBindings(RefChildStr);
	                    if (propRefChildBindings) {
	                        cref_1 = ctx.getValue(ComponentRef_1.CTX_COMPONENT_REF);
	                        propRefChildBindings.forEach(function (b) {
	                            var _a, _b;
	                            var result = cmpdr.select(cref_1, b.bindingName || b.name);
	                            if (!result) {
	                                return;
	                            }
	                            if (cmpdr.isComponentRef(result)) {
	                                if (cmpdr.isComponentRefType(b.type)) {
	                                    ctx.value[b.name] = result;
	                                }
	                                else {
	                                    ctx.value[b.name] = result.instance;
	                                }
	                            }
	                            else if (cmpdr.isElementRef(result)) {
	                                if (cmpdr.isElementRefType(b.type)) {
	                                    ctx.value[b.name] = result;
	                                }
	                                else {
	                                    ctx.value[b.name] = result.nativeElement;
	                                }
	                            }
	                            else {
	                                if (cmpdr.isElementRefType(b.type)) {
	                                    ctx.value[b.name] = (_a = cmpdr.getElementRef(result, ctx.injector)) !== null && _a !== void 0 ? _a : cmpdr.createElementRef(ctx, result);
	                                }
	                                else if (cmpdr.isComponentRefType(b.type)) {
	                                    ctx.value[b.name] = (_b = cmpdr.getComponentRef(result, ctx.injector)) !== null && _b !== void 0 ? _b : cmpdr.createComponentRef(ioc.lang.getClass(result), result, ctx);
	                                }
	                                else {
	                                    ctx.value[b.name] = result;
	                                }
	                            }
	                        });
	                    }
	                    actInjector = ctx.reflects.getActionInjector();
	                    startupRegr = actInjector.getInstance(boot.StartupDecoratorRegisterer);
	                    bindRegs = startupRegr.getRegisterer('Binding');
	                    if (!bindRegs.has(ctx.decorator)) return [3 /*break*/, 2];
	                    return [4 /*yield*/, ioc.chain(bindRegs.getFuncs(this.actInjector, ctx.decorator), ctx)];
	                case 1:
	                    _b.sent();
	                    _b.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _b.sent();
	                    _b.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	var outputDecor = Output.Output.toString();
	exports.BindingOutputHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var bindings, refl, propOutBindings;
	        var _this = this;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    bindings = ctx.getTemplate();
	                    if (!bindings) {
	                        return [2 /*return*/, next()];
	                    }
	                    refl = ctx.getTargetReflect();
	                    propOutBindings = refl === null || refl === void 0 ? void 0 : refl.getBindings(outputDecor);
	                    if (!propOutBindings) return [3 /*break*/, 2];
	                    return [4 /*yield*/, Promise.all(Array.from(propOutBindings.keys()).map(function (n) { return tslib.__awaiter(_this, void 0, void 0, function () {
	                            var binding, filed, expression, pctx_2;
	                            return tslib.__generator(this, function (_a) {
	                                switch (_a.label) {
	                                    case 0:
	                                        binding = propOutBindings.get(n);
	                                        filed = binding.bindingName || binding.name;
	                                        expression = bindings ? bindings[filed] : null;
	                                        if (!!ioc.isNullOrUndefined(expression)) return [3 /*break*/, 2];
	                                        pctx_2 = ParseContext_1.ParseContext.parse(ctx.injector, {
	                                            type: ctx.type,
	                                            parent: ctx,
	                                            bindExpression: expression,
	                                            binding: binding
	                                        });
	                                        return [4 /*yield*/, binding_comp_2.BindingScopeHandle(pctx_2)];
	                                    case 1:
	                                        _a.sent();
	                                        pctx_2.dataBinding.bind(ctx.value);
	                                        setTimeout(function () { return pctx_2.destroy(); });
	                                        _a.label = 2;
	                                    case 2: return [2 /*return*/];
	                                }
	                            });
	                        }); }))];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2: return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	};
	/**
	 * module ater content init handle.
	 *
	 * @export
	 * @class ModuleAfterContentInitHandle
	 * @extends {ResolveHandle}
	 */
	exports.ModuleAfterContentInitHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var target;
	        return tslib.__generator(this, function (_a) {
	            switch (_a.label) {
	                case 0:
	                    target = ctx.value;
	                    if (!(target && ioc.isFunction(target.onAfterContentInit))) return [3 /*break*/, 2];
	                    return [4 /*yield*/, target.onAfterContentInit()];
	                case 1:
	                    _a.sent();
	                    _a.label = 2;
	                case 2:
	                    if (!next) return [3 /*break*/, 4];
	                    return [4 /*yield*/, next()];
	                case 3:
	                    _a.sent();
	                    _a.label = 4;
	                case 4: return [2 /*return*/];
	            }
	        });
	    });
	};
	exports.ParseTemplateHandle = function (ctx, next) {
	    return tslib.__awaiter(this, void 0, void 0, function () {
	        var template, options, _a;
	        return tslib.__generator(this, function (_b) {
	            switch (_b.label) {
	                case 0:
	                    template = ctx.getTemplate();
	                    if (!(!ctx.value && !ctx.type && template)) return [3 /*break*/, 2];
	                    options = {
	                        parent: ctx,
	                        template: template
	                    };
	                    _a = ctx;
	                    return [4 /*yield*/, ctx.injector.getInstance(IComponentBuilder.ComponentBuilderToken)
	                            .resolveTemplate(options, ctx.providers)];
	                case 1:
	                    _a.value = _b.sent();
	                    _b.label = 2;
	                case 2: return [4 /*yield*/, next()];
	                case 3:
	                    _b.sent();
	                    return [2 /*return*/];
	            }
	        });
	    });
	};


	});

	unwrapExports(buildComp);
	var buildComp_1 = buildComp.ParseTemplateHandle;
	var buildComp_2 = buildComp.ModuleAfterContentInitHandle;
	var buildComp_3 = buildComp.BindingOutputHandle;
	var buildComp_4 = buildComp.BindingTemplateRefHandle;
	var buildComp_5 = buildComp.ValifyTeamplateHandle;
	var buildComp_6 = buildComp.ResolveTemplateHanlde;
	var buildComp_7 = buildComp.ResolveTargetRefScope;
	var buildComp_8 = buildComp.ModuleAfterInitHandle;
	var buildComp_9 = buildComp.ModuleInitHandle;
	var buildComp_10 = buildComp.BindingPropertyHandle;
	var buildComp_11 = buildComp.ModuleBeforeInitHandle;
	var buildComp_12 = buildComp.BindingComponentScope;

	var BindingsCache_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BindingsCache = void 0;

	/**
	 * binding cache.
	 *
	 * @export
	 * @abstract
	 * @class BindingCache
	 */
	var BindingsCache = /** @class */ (function () {
	    function BindingsCache() {
	        this.cache = new Map();
	    }
	    BindingsCache.prototype.register = function (decor) {
	        var dkey = ioc.isString(decor) ? decor : decor.toString();
	        if (!this.cache.has(dkey)) {
	            this.cache.set(dkey, new Map());
	        }
	        return this;
	    };
	    BindingsCache.prototype.getCache = function (decor) {
	        return this.cache.get(decor);
	    };
	    BindingsCache.ρAnn = function () {
	        return { "name": "BindingsCache" };
	    };
	    return BindingsCache;
	}());
	exports.BindingsCache = BindingsCache;


	});

	unwrapExports(BindingsCache_1);
	var BindingsCache_2 = BindingsCache_1.BindingsCache;

	var BindingPropTypeAction = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.BindingPropTypeAction = void 0;

	/**
	 * binding property type action.
	 *
	 * @export
	 */
	exports.BindingPropTypeAction = function (ctx, next) {
	    var _a;
	    var refl = ctx.targetReflect;
	    var currDecor = ctx.currDecor;
	    var propBindings = (_a = refl === null || refl === void 0 ? void 0 : refl.getBindings) === null || _a === void 0 ? void 0 : _a.call(refl, currDecor);
	    if (propBindings) {
	        ctx.targetReflect.defines.extendTypes.forEach(function (ty) {
	            var propMetas = ctx.reflects.getPropertyMetadata(currDecor, ty);
	            Object.keys(propMetas).forEach(function (key) {
	                if (!propBindings.has(key)) {
	                    propBindings.set(key, { name: key, type: null });
	                }
	                var binding = propBindings.get(key);
	                var props = propMetas[key];
	                props.forEach(function (prop) {
	                    if (prop.bindingName && !binding.bindingName) {
	                        binding.bindingName = prop.bindingName;
	                    }
	                    if (!binding.type && ioc.isClassType(prop.type)) {
	                        binding.type = prop.type;
	                    }
	                    if (!binding.decorator) {
	                        binding.decorator = prop.decorator;
	                    }
	                    if (!binding.direction) {
	                        binding.direction = prop.direction;
	                    }
	                    if (prop.alias) {
	                        binding.provider = ctx.injector.getToken(prop.provider || prop.type, prop.alias);
	                    }
	                    if (prop.bindingType) {
	                        binding.bindingType = prop.bindingType;
	                    }
	                    if (ioc.isDefined(prop.defaultValue)) {
	                        binding.defaultValue = prop.defaultValue;
	                    }
	                });
	            });
	        });
	    }
	    next();
	};


	});

	unwrapExports(BindingPropTypeAction);
	var BindingPropTypeAction_1 = BindingPropTypeAction.BindingPropTypeAction;

	var ComponentRegAction = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentRegAction = void 0;




	/**
	 * component register action.
	 */
	exports.ComponentRegAction = function (ctx, next) {
	    var currDecor = ctx.currDecor;
	    var injector = ctx.injector;
	    var metas = ctx.reflects.getMetadata(currDecor, ctx.type);
	    var compRefl = ctx.targetReflect;
	    var prdrs;
	    if (!compRefl.getDecorProviders) {
	        prdrs = ctx.reflects.getActionInjector().getInstance(ioc.DecoratorProvider).getProviders(currDecor);
	        if (prdrs) {
	            compRefl.getDecorProviders = function () { return prdrs; };
	        }
	    }
	    else {
	        prdrs = compRefl.getDecorProviders();
	    }
	    if (!compRefl.getBindings) {
	        var caches_1 = prdrs.getInstance(BindingsCache_1.BindingsCache);
	        compRefl.getBindings = function (decor) {
	            return caches_1.getCache(decor);
	        };
	    }
	    var compdr = prdrs.getInstance(ComponentProvider_1.ComponentProvider);
	    compRefl.decorator = currDecor;
	    compRefl.component = true;
	    metas.forEach(function (meta) {
	        if (!meta.selector) {
	            return;
	        }
	        if (meta.selector.indexOf(',') > 0) {
	            meta.selector.split(',').forEach(function (sel) {
	                sel = sel.trim();
	                if (exps.attrExp.test(sel)) {
	                    compRefl.attrSelector = sel;
	                    injector.bindProvider(compdr.toAttrSelectorToken(sel), ctx.type);
	                }
	                else {
	                    compRefl.selector = sel;
	                    injector.bindProvider(compdr.toSelectorToken(sel), ctx.type);
	                }
	            });
	        }
	        else {
	            if (exps.attrExp.test(meta.selector)) {
	                compRefl.attrSelector = meta.selector;
	                injector.bindProvider(compdr.toAttrSelectorToken(meta.selector), ctx.type);
	            }
	            else {
	                compRefl.selector = meta.selector;
	                injector.bindProvider(compdr.toSelectorToken(meta.selector), ctx.type);
	            }
	        }
	    });
	    next();
	};


	});

	unwrapExports(ComponentRegAction);
	var ComponentRegAction_1 = ComponentRegAction.ComponentRegAction;

	var PipeRegAction = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PipeRegAction = void 0;
	/**
	 * component register action.
	 *
	 * @export
	 * @class ComponentRegisterAction
	 * @extends {IocDesignAction}
	 */
	exports.PipeRegAction = function (ctx, next) {
	    var currDecor = ctx.currDecor;
	    var injector = ctx.injector;
	    var metas = ctx.reflects.getMetadata(currDecor, ctx.type);
	    metas.forEach(function (meta) {
	        if (meta.name) {
	            injector.bindProvider(meta.name, ctx.type);
	        }
	    });
	    next();
	};


	});

	unwrapExports(PipeRegAction);
	var PipeRegAction_1 = PipeRegAction.PipeRegAction;

	var RegVaildateAction = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.RegVaildateAction = void 0;

	exports.RegVaildateAction = function (ctx, next) {
	    var ref = ctx.targetReflect;
	    var currDecor = ctx.currDecor;
	    var propVaildates = ref.getBindings(RefChild.RefChild.toString());
	    ctx.targetReflect.defines.extendTypes.forEach(function (ty) {
	        var propMetas = ctx.reflects.getPropertyMetadata(currDecor, ty);
	        Object.keys(propMetas).forEach(function (key) {
	            propVaildates.set(key, propMetas[key]);
	        });
	    });
	    next();
	};


	});

	unwrapExports(RegVaildateAction);
	var RegVaildateAction_1 = RegVaildateAction.RegVaildateAction;

	var ComponentLifecycle = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });


	});

	unwrapExports(ComponentLifecycle);

	var ComponentBuilder_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentBuilder = void 0;










	/**
	 * component builder.
	 *
	 * @export
	 * @class ComponentBuilder
	 * @extends {BuilderService}
	 */
	var ComponentBuilder = /** @class */ (function (_super) {
	    tslib.__extends(ComponentBuilder, _super);
	    function ComponentBuilder() {
	        return _super !== null && _super.apply(this, arguments) || this;
	    }
	    /**
	     * build template.
	     *
	     * @param {ITemplateOption} options
	     * @param {...Provider[]} providers
	     * @returns {Promise<ITemplateContext>}
	     */
	    ComponentBuilder.prototype.buildTemplate = function (options) {
	        var _a, _b;
	        var providers = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            providers[_i - 1] = arguments[_i];
	        }
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var injector, ctx, compPdr, compCtx, tempref;
	            var _c;
	            return tslib.__generator(this, function (_d) {
	                switch (_d.label) {
	                    case 0:
	                        injector = (_a = options.injector) !== null && _a !== void 0 ? _a : (_b = options.parent) === null || _b === void 0 ? void 0 : _b.injector;
	                        ctx = TemplateContext_1.TemplateContext.parse(injector || this.root, options);
	                        providers.length && (_c = ctx.providers).inject.apply(_c, providers);
	                        return [4 /*yield*/, this.reflects.getActionInjector().getInstance(parseTempl.TemplateParseScope)
	                                .execute(ctx)];
	                    case 1:
	                        _d.sent();
	                        if (!ctx.destroyed) {
	                            compPdr = ctx.componentProvider;
	                            if (ioc.isArray(ctx.value) && compPdr && compPdr.parseRef && !ctx.getOptions().attr && !ctx.hasValue(ComponentRef_1.CTX_TEMPLATE_REF)) {
	                                compCtx = void 0;
	                                if (compPdr.isTemplateContext(ctx)) {
	                                    compCtx = ctx;
	                                }
	                                else {
	                                    compCtx = compPdr.createTemplateContext(ctx.injector);
	                                    compCtx.context.copy(ctx.context);
	                                }
	                                tempref = ioc.isArray(ctx.value) ? compPdr.createTemplateRef.apply(compPdr, tslib.__spreadArrays([compCtx], ctx.value)) : compPdr.createTemplateRef(compCtx, ctx.value);
	                                ctx.setValue(ComponentRef_1.CTX_TEMPLATE_REF, tempref);
	                            }
	                        }
	                        return [2 /*return*/, ctx];
	                }
	            });
	        });
	    };
	    ComponentBuilder.prototype.resolveTemplate = function (options) {
	        var providers = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            providers[_i - 1] = arguments[_i];
	        }
	        return tslib.__awaiter(this, void 0, void 0, function () {
	            var ctx;
	            return tslib.__generator(this, function (_a) {
	                switch (_a.label) {
	                    case 0: return [4 /*yield*/, this.buildTemplate.apply(this, tslib.__spreadArrays([options], providers))];
	                    case 1:
	                        ctx = _a.sent();
	                        return [2 /*return*/, !ctx.destroyed ? ctx.getResultRef() : ctx.value];
	                }
	            });
	        });
	    };
	    ComponentBuilder.prototype.serialize = function (component) {
	        var _this = this;
	        if (!component) {
	            return null;
	        }
	        if (ioc.isArray(component)) {
	            return component.map(function (c) { return _this.serialize(c); });
	        }
	        else if (ioc.isString(component) || ioc.isNumber(component) || ioc.isBoolean(component)) {
	            return component;
	        }
	        else if (ioc.isDate(component)) {
	            return component.toString();
	        }
	        else if (ioc.isObject(component)) {
	            var reflects_1 = this.reflects;
	            var compClass_1 = ioc.lang.getClass(component);
	            var refs = reflects_1.get(compClass_1);
	            if (refs && refs.selector) {
	                var json_1 = {};
	                var refselector = refs.getDecorProviders().getInstance(ComponentProvider_1.ComponentProvider);
	                json_1[refselector.getSelectorKey()] = refs.selector;
	                refs.getBindings(Input.Input.toString()).forEach(function (v, key) {
	                    if (reflects_1.hasMetadata(NonSerialize.NonSerialize, compClass_1, key, 'property')) {
	                        return;
	                    }
	                    var val = _this.serialize(component[key]);
	                    if (!ioc.isUndefined(val)) {
	                        json_1[v.bindingName || key] = val;
	                    }
	                });
	                return JSON.parse(JSON.stringify(json_1));
	            }
	            else {
	                return null;
	            }
	        }
	        return null;
	    };
	    ComponentBuilder.ρAnn = function () {
	        return { "name": "ComponentBuilder", "params": { "buildTemplate": ["options", "providers"], "resolveTemplate": ["options", "providers"], "serialize": ["component"] } };
	    };
	    ComponentBuilder = tslib.__decorate([
	        ioc.Singleton(IComponentBuilder.ComponentBuilderToken)
	    ], ComponentBuilder);
	    return ComponentBuilder;
	}(boot.BuilderService));
	exports.ComponentBuilder = ComponentBuilder;


	});

	unwrapExports(ComponentBuilder_1);
	var ComponentBuilder_2 = ComponentBuilder_1.ComponentBuilder;

	var Directive = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Directive = void 0;

	/**
	 * Directive decorator, define for class. use to define the class as Directive.
	 *
	 * @Component
	 */
	exports.Directive = ioc.createClassDecorator('Directive', [
	    function (ctx, next) {
	        if (ioc.isString(ctx.currArg)) {
	            ctx.metadata.selector = ctx.currArg;
	            ctx.next(next);
	        }
	    }
	]);


	});

	unwrapExports(Directive);
	var Directive_1 = Directive.Directive;

	var ComponentsModule_1 = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ComponentsModule = void 0;
























	/**
	 * components module.
	 *
	 * @export
	 * @class ComponentsModule
	 */
	var ComponentsModule = /** @class */ (function () {
	    function ComponentsModule() {
	    }
	    ComponentsModule.prototype.setup = function (container) {
	        var actInjector = container.getActionInjector();
	        actInjector.setValue(IComponentReflect.DefaultComponets, ['@Component']);
	        actInjector.getInstance(ioc.DecoratorProvider)
	            .bindProviders(Component.Component, {
	            provide: BindingsCache_1.BindingsCache,
	            useFactory: function () { return new BindingsCache_1.BindingsCache()
	                .register(Input.Input)
	                .register(Output.Output)
	                .register(RefChild.RefChild)
	                .register(Vaildate.Vaildate); }
	        }, { provide: boot.BuildContext, useClass: ComponentContext_1.ComponentContext }, { provide: ComponentRef_1.ELEMENT_REF, useClass: ComponentRef_1.ElementRef }, { provide: ComponentRef_1.TEMPLATE_REF, useClass: ComponentRef_1.TemplateRef }, { provide: ComponentRef_1.COMPONENT_REF, useClass: ComponentRef_1.ComponentRef }, { provide: ComponentProvider_1.AstResolver, useFactory: function (prd) { return new ComponentProvider_1.AstResolver(prd); }, deps: [ComponentProvider_1.ComponentProvider] });
	        actInjector.regAction(bindingComp.BindingScope)
	            .regAction(parseTempl.TemplateParseScope)
	            .getInstance(boot.ResolveMoudleScope)
	            .use(buildComp.BindingComponentScope)
	            .use(buildComp.ParseTemplateHandle);
	        var cls = 'Class';
	        var prty = 'Property';
	        actInjector.getInstance(ioc.DesignRegisterer)
	            .register(Component.Component, cls, ioc.TypeProviderAction, boot.AnnoationAction, ComponentRegAction.ComponentRegAction)
	            .register(Directive.Directive, cls, ioc.TypeProviderAction, boot.AnnoationAction)
	            .register(Pipe.Pipe, cls, ioc.TypeProviderAction, PipeRegAction.PipeRegAction)
	            .register(Input.Input, prty, BindingPropTypeAction.BindingPropTypeAction)
	            .register(Output.Output, prty, BindingPropTypeAction.BindingPropTypeAction)
	            .register(RefChild.RefChild, prty, BindingPropTypeAction.BindingPropTypeAction)
	            .register(Vaildate.Vaildate, prty, RegVaildateAction.RegVaildateAction);
	        actInjector.getInstance(ioc.RuntimeRegisterer)
	            .register(Component.Component, cls, ioc.RegSingletionAction, ioc.IocSetCacheAction)
	            .register(Directive.Directive, cls, ioc.RegSingletionAction, ioc.IocSetCacheAction);
	        container.registerType(ComponentBuilder_1.ComponentBuilder);
	    };
	    ComponentsModule.ρAnn = function () {
	        return { "name": "ComponentsModule", "params": { "setup": ["container"] } };
	    };
	    tslib.__decorate([
	        tslib.__param(0, ioc.Inject(core.ContainerToken)),
	        tslib.__metadata("design:type", Function),
	        tslib.__metadata("design:paramtypes", [Object]),
	        tslib.__metadata("design:returntype", void 0)
	    ], ComponentsModule.prototype, "setup", null);
	    ComponentsModule = tslib.__decorate([
	        ioc.IocExt()
	    ], ComponentsModule);
	    return ComponentsModule;
	}());
	exports.ComponentsModule = ComponentsModule;


	});

	unwrapExports(ComponentsModule_1);
	var ComponentsModule_2 = ComponentsModule_1.ComponentsModule;

	var src = createCommonjsModule(function (module, exports) {
	Object.defineProperty(exports, "__esModule", { value: true });

	// bindings
	tslib.__exportStar(IBinding, exports);
	tslib.__exportStar(IPipeTransform, exports);
	tslib.__exportStar(onChange, exports);
	tslib.__exportStar(PropBinding_1, exports);
	tslib.__exportStar(EventBinding_1, exports);
	tslib.__exportStar(OneWayBinding_1, exports);
	tslib.__exportStar(TwoWayBinding_1, exports);
	tslib.__exportStar(ParseBinding_1, exports);
	tslib.__exportStar(Events_1, exports);
	// decorators
	tslib.__exportStar(BindingPropMetadata, exports);
	tslib.__exportStar(IComponentMetadata, exports);
	tslib.__exportStar(Component, exports);
	tslib.__exportStar(Input, exports);
	tslib.__exportStar(Output, exports);
	tslib.__exportStar(RefChild, exports);
	tslib.__exportStar(NonSerialize, exports);
	tslib.__exportStar(Vaildate, exports);
	tslib.__exportStar(Pipe, exports);
	tslib.__exportStar(elements, exports);
	tslib.__exportStar(ComponentContext_1, exports);
	// compile
	tslib.__exportStar(ParseContext_1, exports);
	tslib.__exportStar(bindingComp, exports);
	tslib.__exportStar(TemplateContext_1, exports);
	tslib.__exportStar(parseTempl, exports);
	tslib.__exportStar(buildComp, exports);
	// registers
	tslib.__exportStar(BindingsCache_1, exports);
	tslib.__exportStar(BindingPropTypeAction, exports);
	tslib.__exportStar(ComponentRegAction, exports);
	tslib.__exportStar(PipeRegAction, exports);
	tslib.__exportStar(RegVaildateAction, exports);
	tslib.__exportStar(ComponentLifecycle, exports);
	tslib.__exportStar(ComponentRef_1, exports);
	tslib.__exportStar(ComponentProvider_1, exports);
	tslib.__exportStar(IComponentReflect, exports);
	tslib.__exportStar(IComponentBuilder, exports);
	tslib.__exportStar(ComponentBuilder_1, exports);
	tslib.__exportStar(ComponentsModule_1, exports);


	});

	var index = unwrapExports(src);

	return index;

})));
//# sourceMappingURL=components.umd.js.map
